{
  "buttons": {
    "saveSettings": "Enregistrer les paramètres"
  },
  "login": {
    "welcomeBack": "Bon retour !",
    "pleaseLogin": "Veuillez vous connecter à votre compte.",
    "terms": "Conditions d’utilisation.",
    "privacy": "Politique de confidentialité",
    "labels": {
      "username": "Nom d’utilisateur",
      "password": "Mot de passe",
      "rememberMe": "Se souvenir de moi",
      "forgotPassword": "Mot de passe oublié"
    },
    "code": {
      "enter": "Saisir le code de l’e-mail",
      "resend": "Renvoyer le code"
    },
    "error": {
      "unexpected": "Une erreur inattendue s’est produite. Veuillez réessayer.",
      "credentials": "Adresse e-mail ou mot de passe incorrect. Veuillez réessayer.",
      "unknown": "Une erreur inconnue s’est produite. Veuillez réessayer.",
      "otpFailed": "Échec de la vérification. Veuillez réessayer.",
      "otpInvalid": "Code de vérification incorrect. Veuillez réessayer.",
      "enterCode": "Veuillez saisir le code de vérification."
    }
  },
  "register": {
    "title": "Invitation",
    "welcome": "Bienvenue !",
    "setPassword": "Veuillez définir votre mot de passe",
    "label": {
      "passwordConfirm": "Confirmer le mot de passe"
    },
    "message": {
      "passwordSet": "Votre mot de passe a été défini avec succès. Vous pouvez maintenant accéder à la page de connexion.",
      "confirm": "Merci pour votre inscription.",
      "seeYouAround": "À bientôt !",
      "genericError": "Une erreur est survenue. Veuillez réessayer !",
      "expiredToken": "Ce lien d’invitation a expiré. Veuillez demander une nouvelle invitation à la personne qui vous a invité.",
      "invalidToken": "Ce lien d’invitation n’est plus valide. Veuillez demander une nouvelle invitation à la personne qui vous a invité.",
      "declined": "Votre invitation a été refusée."
    },
    "button": {
      "login": "Connexion",
      "register": "S'inscrire"
    }
  },
  "resetPassword": {
    "title": "Réinitialiser le mot de passe",
    "message": {
      "emailSent": "Un email a été envoyé à {email} avec les instructions pour réinitialiser votre mot de passe. Veuillez vérifier votre boîte de réception.",
      "passwordReset": "Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant accéder à la page de connexion.",
      "invalidToken": "Votre jeton n’est pas valide. Veuillez faire une nouvelle demande pour réinitialiser votre mot de passe.",
      "genericError": "Une erreur est survenue. Veuillez réessayer !"
    },
    "button": {
      "login": "Connexion"
    }
  },
  "clients": {
    "addClient": "Ajouter un nouveau client",
    "createClient": "Créer un client",
    "cancel": "Annuler",
    "deactivated": "Désactivé",
    "reactivate": "Réactiver",
    "deleteClient": "Supprimer définitivement",
    "clientName": "Quel est le nom du client ?",
    "projects": "Nombre de projets de carte :",
    "users": "Nombre d’utilisateurs :",
    "access": "Demander l’accès",
    "searchPlaceholder": "Rechercher des clients..."
  },
  "mapOverview": {
    "headerTitle": "Aperçu des cartes",
    "createMap": "Créer une nouvelle carte",
    "live": "Vue en direct",
    "draft": "Aperçu",
    "edit": "Modifier la carte",
    "clone": "Cloner la carte",
    "cloneTemplate": "Cloner le modèle",
    "delete": "Supprimer la carte",
    "access": "Accès :",
    "lastEdited": "Dernière modification :",
    "mapLiveQuotaToggleLabel": "En direct",
    "searchPlaceholder": "Rechercher des cartes...",
    "cloneToClient": {
      "action": "Cloner vers un autre client",
      "title": "Cloner la carte vers un autre client",
      "description": "Choisissez le client qui doit recevoir une copie de « {map} ».",
      "currentClient": "client actuel",
      "noClients": "Aucun client trouvé.",
      "cancel": "Annuler",
      "confirm": "Cloner la carte",
      "confirmTo": "Cloner vers {client}",
      "done": "« {map} » a été créée chez {client}.",
      "open": "Ouvrir dans le Map Builder",
      "close": "Fermer",
      "failed": "La carte n’a pas pu être clonée."
    }
  },
  "overviewSort": {
    "label": "Trier par",
    "nameAsc": "Nom (A–Z)",
    "nameDesc": "Nom (Z–A)",
    "createdDesc": "Création (plus récentes d’abord)",
    "createdAsc": "Création (plus anciennes d’abord)",
    "modifiedDesc": "Dernière modification (plus récentes d’abord)",
    "modifiedAsc": "Dernière modification (plus anciennes d’abord)",
    "idAsc": "ID (croissant)",
    "idDesc": "ID (décroissant)"
  },
  "overviewList": {
    "loadMore": "Afficher plus",
    "loading": "Chargement en cours…",
    "end": "{count} au total, tous chargés",
    "empty": "Aucun résultat ne correspond à votre filtre"
  },
  "mapAccess": {
    "created": "accès limité",
    "draft": "accès limité",
    "metered": "accès partiellement limité",
    "published": "accessible au public"
  },
  "header": {
    "button": {
      "buyLicense": "Acheter une licence"
    },
    "link": {
      "preview": "Aperçu des modifications",
      "live": "Version en direct"
    }
  },
  "dashboardOptions": {
    "createMap": "Créer la carte",
    "drawShapes": "Dessiner des formes",
    "drawText": "Texte sur la carte",
    "drawEdges": "Dessiner une connexion",
    "globalDesign": "Définir le design global",
    "objectTemplates": "Gérer les modèles d’objets",
    "mapSettings": "Paramètres de la carte",
    "mapLanguages": "Langues et traductions",
    "organizeContent": "Organiser le contenu",
    "contentForm": "Formulaire de contenu",
    "editorsNote": "Note de l’éditeur",
    "glossary": "Glossaire",
    "references": "Liste des références",
    "headerBar": "Barre d’en-tête",
    "tableOfContent": "Table des matières",
    "mediaAssets": "Gérer les ressources média",
    "mediaTemplates": "Modèles de média",
    "webSettings": "Gérer les paramètres web",
    "socialNetworks": "Ajouter les réseaux sociaux",
    "cookieConsent": "Ajouter le consentement aux cookies",
    "seo": "Ajouter les paramètres SEO",
    "mapUrl": "Gérer l’URL de la carte",
    "mapAccess": "Gérer l’accès à la carte",
    "mapEmbed": "Code d’intégration de la carte",
    "nodeDesign": "Design du nœud de forme",
    "nodeContent": "Modifier le contenu",
    "nodeVisibility": "Gérer la visibilité du nœud",
    "edgeDesign": "Design de l’arête de forme",
    "edgeVisibility": "Gérer la visibilité de l’arête",
    "quizTool": "Outil de quiz"
  },
  "layerOptions": {
    "settings": "Paramètres du calque",
    "level": "Niveau Z",
    "edges": "Toutes les arêtes",
    "layer": "Calque",
    "node": "Nœud"
  },
  "options": {
    "style": {
      "dotted": "Pointillé",
      "solid": "Solide",
      "dashed": "Tirets"
    },
    "textPosition": {
      "topLeft": "En haut à gauche",
      "top": "En haut",
      "topRight": "En haut à droite",
      "left": "À gauche",
      "center": "Centre",
      "right": "À droite",
      "bottomLeft": "En bas à gauche",
      "bottom": "En bas",
      "bottomRight": "En bas à droite"
    },
    "contentBar": {
      "detachedSmall": "Détaché (petit)",
      "detachedMedium": "Détaché (moyen)",
      "detachedLarge": "Détaché (grand)",
      "panelSmall": "Panneau latéral (petit)",
      "panelLarge": "Panneau latéral (grand)"
    },
    "repeat": {
      "noRepeat": "Aucune répétition",
      "repeat": "Répéter",
      "repeatX": "Répéter-x",
      "repeatY": "Répéter-y"
    },
    "size": {
      "fill": "Remplir",
      "cover": "Couvrir",
      "contain": "Contenir",
      "none": "Aucun"
    }
  },
  "field": {
    "w": "L",
    "h": "H",
    "px": "px",
    "color": "Couleur",
    "appearance": {
      "color": "Couleur du nœud",
      "crop": "Recadrer le média avec la forme",
      "border": "Bordure",
      "shadow": "Ombre",
      "media": "Média",
      "mediaUrl": "Ajouter une URL de média",
      "mediaSize": "Taille du média",
      "opacity": "Opacité",
      "style": "Style"
    },
    "typography": {
      "textPosition": "Position du texte",
      "paragraphSpacing": "Espacement des paragraphes, ‹em› est relatif à la taille de police du paragraphe."
    }
  },
  "objectTemplate": {
    "placeholder": "Choisir un modèle",
    "label": "Mettre à jour ou enregistrer un nouveau modèle d’objet",
    "create": "Créer un nouveau modèle",
    "createShort": "Créer modèle",
    "update": "Mettre à jour le modèle",
    "createdName": "Donnez un nom à votre nouveau modèle",
    "size": "Taille :",
    "font": "Police :",
    "title": "Titre",
    "nodeTemplates": "Modèles d’objets nœud",
    "edgeTemplates": "Modèles d’objets arête",
    "backButton": "Retour à l’aperçu"
  },
  "sidebar": {
    "title": {
      "nodeDesign": "Modifier le design de la forme",
      "textDesign": "Modifier le design du texte sur le canevas",
      "nodeVisibility": "Gérer la visibilité de l’élément",
      "edgeDesign": "Modifier le design de l’arête",
      "edgeVisibility": "Gérer la visibilité de l’arête",
      "globalDesign": "Paramètres de design global",
      "objectTemplates": "Modèles d’objets",
      "mapSettings": "Données de base de la carte"
    },
    "nodeDesign": {
      "clone": "Cloner le nœud",
      "delete": "Supprimer le nœud",
      "placeholder": {
        "point": "Nouveau point"
      },
      "label": {
        "name": "Nom du nœud",
        "shape": "Forme",
        "transformation": "Transformation",
        "appearance": "Apparence"
      },
      "title": {
        "appearance": "Apparence de la forme",
        "typography": "Typographie",
        "objectTemplate": "Modèle d’objet"
      }
    },
    "visibility": {
      "title": {
        "layers": "Visibilité sur tous les calques",
        "devices": "Visibilité sur différents appareils"
      },
      "label": {
        "first": "Premier calque",
        "last": "Dernier calque",
        "mobile": "Mobile",
        "tablet": "Tablette",
        "desktop": "Bureau"
      }
    },
    "edgeDesign": {
      "title": {
        "appearance": "Apparence de l’arête",
        "lettering": "Lettrage"
      },
      "label": {
        "line": "Type de ligne",
        "lineStart": "Choisir le début de ligne",
        "lineEnd": "Choisir la fin de ligne",
        "start": "Texte d’étiquette début",
        "center": "Texte d’étiquette centre",
        "end": "Texte d’étiquette fin"
      },
      "placeholder": {
        "text": "Ajouter un texte d’étiquette"
      }
    },
    "globalDesign": {
      "title": {
        "content": "Paramètres de contenu",
        "sections": "Sections de contenu supplémentaires",
        "tooltip": "Contenu de l’info-bulle",
        "table": "Table des matières"
      },
      "label": {
        "content": {
          "narrow": "Panneau latéral étroit",
          "wide": "Panneau latéral large",
          "detachedLarge": "Boîte de contenu détachée grande",
          "detachedSmall": "Boîte de contenu détachée petite",
          "detachedMedium": "Boîte de contenu détachée moyenne"
        },
        "sections": {
          "info": "Informations supplémentaires",
          "nav": "Navigation"
        }
      }
    },
    "mapSettings": {
      "title": {
        "canvas": "Canevas",
        "bg": "Arrière-plan",
        "behavior": "Comportement des nœuds en vue directe",
        "palette": "Palette de couleurs pour les contrôles",
        "download": "Options pour télécharger la carte",
        "assistant": "Assistant KAIA"
      },
      "label": {
        "dimension": "Dimension",
        "expansion": "Direction d’expansion",
        "zoom": "Niveaux de zoom",
        "bgFixed": "Image d’arrière-plan fixe",
        "position": "Position",
        "repeat": "Répéter",
        "size": "Taille",
        "transparency": "Transparence",
        "highlight": "Mettre en évidence les nœuds lus",
        "tableOfContents": "Afficher la table des matières",
        "searchEngine": "Afficher le moteur de recherche",
        "darkMode": "Mode sombre (suggéré pour les arrière-plans clairs)",
        "brightMode": "Mode clair (suggéré pour les arrière-plans sombres)",
        "nodesHighlights": "Mettre en évidence les connexions directes",
        "nodesList": "Afficher les connexions directes sous le contenu",
        "highlightBackdrop": "Couleur d’arrière-plan lors de la mise en évidence des points",
        "modificationDate": "Afficher la date des dernières modifications sous le contenu",
        "assistant": "Activer KAIA pour cette carte"
      },
      "button": {
        "exportContent": "Télécharger les articles en CSV",
        "exportNodesContent": "Télécharger les articles au format TXT",
        "exportGlossary": "Télécharger termes du glossaire",
        "exportSnapshot": "Instantané de la carte (dernier calque)",
        "exportMedia": "Télécharger les fichiers média"
      },
      "message": {
        "media": "Téléchargement de tous les fichiers média en cours. Selon la quantité et la taille du contenu de votre bibliothèque, cela peut prendre du temps."
      },
      "tooltip": {
        "downloadInProgress": "Veuillez patienter jusqu’à ce que les données soient préparées pour le téléchargement"
      },
      "hint": {
        "assistant": "Si KAIA est désactivé, l’assistant n’est pas proposé lors de l’édition de cette carte. Il reste disponible dans tes autres cartes."
      }
    }
  },
  "common": {
    "soon": "Disponible prochainement",
    "duplicated": "Vous êtes déjà connecté !",
    "language": "Langue"
  },
  "tooltip": {
    "editMap": "Modifier les paramètres de la carte",
    "preview": "Voir l’aperçu des modifications actuelles",
    "version": "Gérer les versions",
    "mapOverview": "Accéder à l’aperçu des cartes",
    "generalSettings": "Gérer les paramètres généraux",
    "knowledge": "Base de connaissances",
    "userSettings": "Paramètres utilisateur",
    "clients": "Clients",
    "logout": "Se déconnecter",
    "noPermission": "Vous n’avez pas accès",
    "noAccess": "Non disponible dans votre abonnement",
    "readPermission": "Veuillez demander à votre administrateur \n d’obtenir l’accès en édition.",
    "adminPermission": "Vous avez besoin des droits d’administrateur pour accéder",
    "confirmTranslation": "Pour confirmer la traduction, cochez la case à côté de chaque langue.",
    "languageBoardActive": "Utilisez ce bouton pour basculer entre les langues afin de gérer rapidement toutes les traductions. Les paramètres avancés et complets se trouvent dans le formulaire de contenu.",
    "languageBoardInactive": "Ceci est l’ID de la langue par défaut choisie. Actuellement, vous n’avez pas ajouté de langue supplémentaire. Veuillez gérer vos paramètres de langue dans les paramètres spécifiques à la carte.",
    "gifControlAnimation": "Contrôle d’animation GIF",
    "visitors": "Qui modifie cette carte en ce moment",
    "inviteMembers": "Inviter des membres de l’équipe",
    "mapProtocol": "Journal de la carte",
    "releaseNotes": "Nouveautés"
  },
  "message": {
    "success": "Contenu enregistré avec succès !",
    "mediaSuccess": "Contenu du fichier {id} enregistré avec succès",
    "nodeCloneSuccess": "Le clone du nœud {id} a été créé",
    "nodeCloneError": "Une erreur s’est produite lors de la création du clone du nœud",
    "nodeCreatedSuccess": "Le nœud {id} a été créé",
    "nodeCreatedError": "Une erreur s’est produite lors de la création du nœud",
    "nodeRemovedSuccess": "Le nœud {id} a été supprimé",
    "nodeRemovedError": "Une erreur s’est produite lors de la suppression du nœud",
    "nodeDesignSuccess": "Le design du nœud {id} a été mis à jour",
    "nodeDesignError": "Une erreur s’est produite lors de la mise à jour du design du nœud {id}",
    "nodeContentSuccess": "Le contenu du nœud {id} a été mis à jour",
    "nodeContentError": "Une erreur s’est produite lors de la mise à jour du contenu du nœud {id}",
    "nodeVisibilitySuccess": "La visibilité du nœud {id} a été mise à jour",
    "nodeVisibilityError": "Une erreur s’est produite lors de la mise à jour de la visibilité du nœud {id}",
    "nodeVisibilityRestored": "Visibilité du nœud {id} restaurée",
    "nodePositionSuccess": "La position du nœud a été modifiée",
    "nodePositionError": "Une erreur s’est produite lors de la modification de la position du nœud",
    "nodesPositionsSuccess": "Les positions des nœuds ont été modifiées",
    "nodesPositionsError": "Une erreur s’est produite lors de la modification des positions des nœuds",
    "nodesOrderSuccess": "L’ordre des nœuds a été modifié",
    "nodesOrderError": "Erreur lors de la modification de l’ordre des nœuds",
    "nodeHiddenSuccess": "Nœud masqué avec succès",
    "nodeHiddenError": "Une erreur s’est produite lors du masquage du nœud",
    "nodeLockedSuccess": "Nœud verrouillé avec succès",
    "nodeLockedError": "Une erreur s’est produite lors du verrouillage du nœud",
    "layerHiddenSuccess": "Calque masqué avec succès",
    "layerHiddenError": "Une erreur s’est produite lors du masquage du calque",
    "layerLockedSuccess": "Calque verrouillé avec succès",
    "layerLockedError": "Une erreur s’est produite lors du verrouillage du calque",
    "templateApplySuccess": "Modèle appliqué avec succès",
    "templateApplyError": "Une erreur s’est produite lors de l’application du modèle",
    "templateRestoreSuccess": "Modèle restauré avec succès",
    "templateRestoreError": "Une erreur s’est produite lors de la restauration du modèle",
    "templateCreateSuccess": "Modèle créé avec succès",
    "templateCreateError": "Une erreur s’est produite lors de la création du modèle",
    "templateNamedCreateSuccess": "Le modèle {name} a été créé",
    "templateNamedCreateError": "Une erreur s’est produite lors de la création du modèle {name}",
    "templateUpdateSuccess": "Modèle mis à jour avec succès",
    "templateUpdateError": "Une erreur s’est produite lors de la mise à jour du modèle",
    "templateNamedUpdateSuccess": "Le modèle {name} a été mis à jour",
    "templateRemoveSuccess": "Le modèle a été supprimé",
    "templateRemoveError": "Une erreur s’est produite lors de la suppression du modèle",
    "edgeCreateSuccess": "L’arête {id} a été créée",
    "edgeCreateError": "Une erreur s’est produite lors de la création de l’arête",
    "edgeRemoveSuccess": "L’arête {id} a été supprimée",
    "edgeRemoveError": "Une erreur s’est produite lors de la suppression de l’arête",
    "edgesRemoveSuccess": "Toutes les arêtes ont été supprimées",
    "edgesRemoveError": "Une erreur s’est produite lors de la suppression des arêtes liées",
    "edgesRelatedRemoveSuccess": "Les arêtes liées ont été supprimées",
    "edgesRelatedRemoveError": "Une erreur s’est produite lors de la suppression des arêtes liées",
    "edgeDesignSuccess": "Le design de l’arête {id} a été mis à jour",
    "edgeDesignError": "Une erreur s’est produite lors de la mise à jour du design de l’arête {id}",
    "edgeContentSuccess": "Le contenu de l’arête {id} a été mis à jour",
    "edgeContentError": "Une erreur s’est produite lors de la mise à jour du contenu de l’arête {id}",
    "edgeVisibilitySuccess": "La visibilité de l’arête a été mise à jour",
    "edgeVisibilityError": "Une erreur s’est produite lors de la mise à jour de la visibilité de l’arête",
    "edgeVisibilityRestored": "Visibilité de l’arête restaurée",
    "globalUpdateSuccess": "Le design global a été mis à jour",
    "globalUpdateError": "Une erreur s’est produite lors de la mise à jour du design global",
    "mapSettingsSuccess": "Les paramètres de la carte ont été modifiés",
    "mapSettingsError": "Une erreur s’est produite lors de la modification des paramètres de la carte",
    "userLanguageSuccess": "La langue a été modifiée",
    "userLanguageError": "Une erreur s’est produite lors de la modification de la langue",
    "translatedUnchecked": "Attention ! Les cases de confirmation des langues supplémentaires n’ont pas encore été cochées.",
    "translationsCare": "Veuillez faire attention à vos traductions",
    "downloadMediaSuccess": "Les fichiers média ont été téléchargés",
    "downloadMediaError": "Une erreur s’est produite lors du téléchargement des fichiers média"
  },
  "shortcuts": {
    "title": "Raccourcis clavier",
    "close": "Fermer",
    "hint": "Appuyez sur ? pour afficher/masquer ce panneau",
    "keys": {
      "ctrl": "Ctrl",
      "cmd": "⌘",
      "shift": "Maj",
      "enter": "Entrée",
      "esc": "Échap",
      "del": "Suppr",
      "space": "Espace",
      "drag": "glisser",
      "click": "clic"
    },
    "groups": {
      "canvas": "Zone de travail",
      "title": "Titre du point",
      "help": "Aide"
    },
    "items": {
      "delete": "Supprimer le(s) point(s) sélectionné(s)",
      "deselect": "Tout désélectionner",
      "duplicate": "Dupliquer le point",
      "selectAll": "Sélectionner tous les points",
      "nudge": "Déplacer le point (Maj pour de plus grands pas)",
      "editTitle": "Modifier le titre du point",
      "pan": "Déplacer la carte",
      "extendSelection": "Ajouter / retirer le point de la sélection",
      "lasso": "Sélection au lasso",
      "lineBreak": "Insérer un saut de ligne",
      "nbsp": "Insérer une espace insécable",
      "softHyphen": "Insérer un trait d'union conditionnel",
      "bold": "Basculer le gras",
      "italic": "Basculer l'italique",
      "toggle": "Afficher / masquer ce panneau"
    }
  },
  "quickEditBar": {
    "kaia": {
      "tooltip": "Générer du contenu avec votre LLM connecté",
      "tooltipFacts": "Générer des faits clés avec votre LLM connecté",
      "tooltipReferences": "Générer des références avec votre LLM connecté",
      "unavailable": "Aucun LLM connecté. Demandez à un administrateur d'en connecter un dans les paramètres API pour générer du contenu.",
      "failed": "Échec de la génération de contenu. Connectez un LLM dans les paramètres API ou rédigez le contenu manuellement."
    },
    "nav": "Ajouter la navigation :",
    "prev": "précédent",
    "next": "suivant",
    "visibilityFrom": "Visibilité à partir de :",
    "visibilityOn": "Visibilité sur :",
    "linkNode": "Lier le nœud à :",
    "linkBlocked": "Il n’est pas possible de lier le nœud à une URL et de fournir du contenu en même temps. Pour ajouter un lien, veuillez supprimer le contenu dans le formulaire de contenu.",
    "textStart": "Début du texte",
    "textEnd": "Fin du texte",
    "moreOptions": "Plus d’options",
    "size": "Taille",
    "fontColor": "Couleur de police",
    "contentNotSaved": "Le contenu n’est pas enregistré.<br>Confirmez votre action :",
    "shapeSettings": "Paramètres de forme",
    "nodeAppearance": "Apparence du nœud",
    "fontSettings": "Paramètres de police",
    "titleShortcuts": "Raccourcis — Maj+Entrée : saut de ligne, Ctrl+Maj+Espace : espace insécable, Ctrl+- : trait d'union conditionnel, Ctrl+B / Ctrl+I : gras / italique",
    "tooltips": {
      "noBold": "Gras non disponible",
      "noItalic": "Italique non disponible",
      "noBoldItalic": "Il n’y a pas de police `Gras Italique`"
    }
  },
  "popup": {
    "sidebar": {
      "title": {
        "content": "Gérer le contenu de votre carte",
        "web": "Gérer les paramètres spécifiques au web",
        "client": "Paramètres de votre compte",
        "user": "Paramètres utilisateur",
        "map": "Paramètres de la carte"
      },
      "section": {
        "content": {
          "mediaAssets": "Ressources média"
        },
        "web": {
          "social": "Réseaux sociaux",
          "cookie": "Consentement aux cookies",
          "seo": "SEO",
          "url": "URL spécifique à la carte",
          "access": "Restriction d’accès",
          "embed": "Code d’intégration"
        },
        "client": {
          "general": "Paramètres généraux",
          "user": "Gestion des utilisateurs",
          "analytics": "Paramètres d’analyse",
          "api": "Gérer l’API",
          "invoices": "Factures",
          "billing": "Données de facturation",
          "subscription": "Gérer l’abonnement",
          "payment": "Paramètres de paiement"
        },
        "user": {
          "profile": "Profil",
          "password": "Mot de passe"
        },
        "map": {
          "settings": "Paramètres généraux de la carte",
          "versions": "Versions de la carte"
        },
        "templates": {}
      }
    },
    "testingPeriod": {
      "title": "Le temps passe vite !",
      "description": "Votre période d’essai gratuite pour {package} a expiré. Achetez une licence pour continuer à travailler sur vos cartes.",
      "package": {
        "singleLicense": "Licence unique"
      }
    },
    "askAdmin": {
      "title": "Contactez votre administrateur",
      "description": "Vous n’avez pas accès à cette fonctionnalité. Veuillez demander de l’aide à votre administrateur.",
      "button": "Contacter l’admin",
      "message": {
        "success": "Message envoyé avec succès !",
        "error": "Une erreur s’est produite lors de l’envoi du message !"
      }
    },
    "choosingLang": {
      "title": "Choisissez votre langue :",
      "description": "Avant de lancer votre carte, veuillez définir avec quelle langue vous commencerez votre projet.",
      "note": "Vous pouvez ajouter des langues supplémentaires plus tard dans les paramètres généraux de la carte.",
      "button": "Lancer"
    },
    "translationsOverview": {
      "overview": {
        "title": "Aperçu et progression des traductions",
        "table": {
          "text": "Textes à traduire",
          "defaultLanguage": "Langue par défaut",
          "defaultLabels": "Étiquettes par défaut"
        },
        "message": {
          "warning": "Les étiquettes par défaut ne sont disponibles qu’en anglais. Veuillez ajouter des traductions pour la langue par défaut."
        }
      },
      "labels": {
        "defaultLabels": {
          "title": "Étiquettes par défaut",
          "tooltip": "Les termes par défaut identifient des zones et sections spécifiques dans la carte en direct."
        },
        "additionalSources": {
          "title": "Sources supplémentaires",
          "tooltip": "Si des sources supplémentaires sont stockées en plus d’un fichier BibTex, elles sont séparées des autres avec le titre \"sources supplémentaires\"."
        },
        "bibtexSources": {
          "title": "Collection et aperçu des sources dans un fichier BibTeX",
          "tooltip": "Ce titre est placé au-dessus d’une liste de sources dans la table des matières, qui sont extraites d’un fichier BibTeX. Lorsque les sources sont téléchargées avec un fichier BibTeX, tout le contenu qu’elles contiennent apparaît automatiquement dans cette liste."
        },
        "editorsNote": {
          "title": "Note de l’éditeur",
          "tooltip": "Ce terme se trouve sur un onglet en bas de la carte, qui peut être utilisé pour ouvrir un éditorial avec des informations générales sur le projet."
        },
        "glossary": {
          "title": "Glossaire",
          "tooltip": "Si un glossaire est maintenu, ce terme apparaît comme une catégorie dans la table des matières. Il liste tous les termes et leurs définitions."
        },
        "interviewPartners": {
          "title": "Partenaires d’interview",
          "tooltip": "Ce terme apparaît dans la table des matières dès que des articles ou des fichiers média ont été marqués comme \"partenaires d’interview\" avec le code court correspondant. Il liste toutes les personnes marquées de cette façon."
        },
        "listOfArticles": {
          "title": "Liste des articles",
          "tooltip": "Ce terme décrit une catégorie de la table des matières dans laquelle tous les articles et aspects thématiques sont listés."
        },
        "logIn": {
          "title": "Se connecter",
          "tooltip": "Si la carte a été publiée dans un environnement restreint, vous devez vous y connecter pour accéder au contenu."
        },
        "logOut": {
          "title": "Se déconnecter",
          "tooltip": "Si vous êtes connecté à une carte non publique, vous pouvez vous déconnecter ici."
        },
        "searchAllResults": {
          "title": "tous les résultats",
          "tooltip": "Dans la recherche interne de la carte, le nombre de tous les résultats est affiché au-dessus des résultats de recherche."
        },
        "searchNoResultsFound": {
          "title": "Aucun résultat trouvé",
          "tooltip": "Si aucun résultat n’est trouvé dans la recherche interne de la carte, ce texte par défaut apparaît."
        },
        "searchResultArticle": {
          "title": "Article",
          "tooltip": "Dans la recherche interne de la carte, le nombre de tous les résultats de recherche est divisé en sous-catégories plus spécifiques. Articles montre tous les résultats qui apparaissent dans les articles, Fichiers média montre tous les résultats qui apparaissent dans les médias."
        },
        "searchResultMap": {
          "title": "Carte",
          "tooltip": ""
        },
        "searchResultMediaAsset": {
          "title": "Média",
          "tooltip": "Dans la recherche interne de la carte, le nombre de tous les résultats de recherche est divisé en sous-catégories plus spécifiques. Articles montre tous les résultats qui apparaissent dans les articles, Fichiers média montre tous les résultats qui apparaissent dans les médias."
        },
        "searchResultNode": {
          "title": "Point d’information",
          "tooltip": ""
        },
        "searchSeparateTermsByComma": {
          "title": "Séparer les termes par une virgule",
          "tooltip": "La recherche peut être affinée davantage dans le champ de recherche avancée. Le texte d’espace réservé dans les champs de formulaire donne une indication sur la façon dont plusieurs termes doivent être saisis."
        },
        "searchTerm": {
          "title": "Terme de recherche",
          "tooltip": "Ce terme apparaît comme espace réservé dans le champ de recherche de la recherche interne de la carte."
        },
        "sources": {
          "title": "Sources",
          "tooltip": "Si une liste de sources est maintenue, la catégorie \"Sources\" apparaît dans la table des matières"
        },
        "tableOfContents": {
          "title": "Table des matières",
          "tooltip": "Ce terme apparaît comme titre parent dans la table des matières."
        }
      }
    },
    "mapTemplates": {
      "projectName": "Donnez un nom au projet",
      "create": "Créer une carte",
      "createBlanc": "Créer une carte vierge",
      "createTemplate": "Créer un nouveau modèle",
      "preview": "Aperçu",
      "selectTemplate": "Sélectionner un modèle",
      "selectWarningTop": "Pour choisir ce modèle",
      "selectWarningBottom": "veuillez d’abord créer une version en direct",
      "editTemplate": "Modifier le modèle",
      "deleteTemplate": "Supprimer le modèle",
      "templateName": "Donnez un nom au modèle",
      "cancel": "Annuler",
      "allTemplates": "Tous les modèles",
      "myTemplates": "Mes modèles",
      "allTitle": "Commencez avec une carte vierge ou choisissez un modèle",
      "templateTitle": "Modèles {type}",
      "themes": {
        "basic": "Basique",
        "process": "Processus",
        "strategy": "Stratégie",
        "business": "Affaires",
        "marketing": "Marketing",
        "personal": "Votre personnel",
        "my": "Mon"
      },
      "dimensions": "Dimensions :",
      "layers": "Calques :",
      "palette": "Palette de couleurs :",
      "section": "Section :",
      "templatesTitle": "Modèles KontextMaps",
      "templateCategories": "Catégories de modèles",
      "learnMore": "En savoir plus",
      "useTemplate": "Utiliser le modèle"
    },
    "duplicate": {
      "doubleLogin": "Double connexion !",
      "message": "Notre système signale que vous êtes déjà connecté au Map Builder pour cette carte avec ce compte utilisateur. Avez-vous ouvert cette carte dans le Map Builder dans un autre navigateur ou un autre onglet ?",
      "back": " Si oui : Veuillez fermer celui-ci.",
      "reload": " Si non : Veuillez recharger cette fenêtre.",
      "buttons": {
        "back": "Me ramener",
        "reload": "Recharger la page"
      }
    },
    "confirm": {
      "cannotUndone": "Ceci ne peut pas être annulé.",
      "canUndo": "Vous pouvez annuler ceci avec le bouton d’annulation.",
      "youSure": "Êtes-vous sûr ?",
      "stopMe": "Oh non, veuillez m’arrêter !",
      "sure": "Oui, j’en suis sûr à 100% !",
      "warning": "Vous êtes sur le point de {action} ",
      "quotaReached": "Vous avez atteint le nombre maximum de {type}. Veuillez nous contacter via : {email} pour obtenir plus de {type} ou pour mettre à niveau votre plan.",
      "quotaLiveMapsReached": "Vous n’avez plus de cartes en direct. Désélectionnez un autre projet ou mettez à niveau votre plan.",
      "quotaLiveMapsReachedAdmin": "Vous n’avez plus de cartes en direct. Désélectionnez un autre projet ou contactez un administrateur pour mettre à niveau votre plan.",
      "quotaType": {
        "template": "modèles",
        "map": "projets de carte"
      },
      "showMessage": "Ne plus afficher ce message (pendant la session actuelle).",
      "publishedMapDeleteWarning": "Vous êtes sur le point de supprimer la carte en direct de ce projet. Après cela, vous ne conserverez que la dernière version d’aperçu de la carte. Voulez-vous continuer ?",
      "noLiveVersion": "Cette carte n’a pas de version en direct. Veuillez d’abord la sélectionner comme carte en direct dans l’aperçu des cartes.",
      "actions": {
        "deleteClient": "supprimer un client.",
        "deactivateClient": "désactiver un client.",
        "deleteMap": "supprimer une carte.",
        "deleteNode": "supprimer un nœud.",
        "deleteLayer": "supprimer un calque.",
        "deleteEdge": "supprimer une arête.",
        "deleteEdges": "supprimer toutes les arêtes.",
        "deleteAsset": "supprimer une ressource.",
        "resetMap": "réinitialiser la carte.",
        "deselectProject": "Désélectionner un autre projet",
        "upgradePlan": "Mettre à niveau le plan",
        "deleteLiveMap": "Oui ! Supprimez-la !",
        "keepLiveMap": "Oh non ! Retenez-moi !",
        "confirm": "Faisons cela",
        "cancel": "Peut-être plus tard",
        "deleteRelatedEdges": "Confirmer et supprimer les arêtes",
        "cancelDeleteRelatedEdges": "Noooooooooon !!!",
        "deletePackage": "supprimer un forfait."
      },
      "tocWarning": "Ce point est inclus dans l’ordre individuel de la table des matières.",
      "deleteAndManageToc": "Supprimer et gérer dans la table des matières",
      "tocDeletedNodesAlert": "Attention requise : Certains points de l’ordre individuel ont été supprimés et doivent être gérés.",
      "largeScreens": "Le Map Builder est optimisé pour l’édition sur de grands écrans. Une version mobile limitée sera bientôt disponible.",
      "switchScreen": "Pour créer, éditer et gérer vos cartes, veuillez passer à un écran plus grand.",
      "deleteEdgesNotOverlappedMessage": "Conflit de calque ! Une ou plusieurs arêtes de connexion au point dont vous êtes sur le point de changer les paramètres de calque ne seraient plus connectées à ce point et se retrouveraient dans le vide.",
      "liveMapSeats": {
        "title": "Toutes les places de carte en direct sont prises.",
        "options": "Vous avez deux options :",
        "overview": "1. aller à l’aperçu des cartes et désactiver le statut en direct d’un autre projet, ou",
        "upgrade": "2. écrire à notre équipe de vente pour mettre à niveau votre licence.",
        "upgradeViaAdmin": "2. écrire à un administrateur pour étendre la licence.",
        "buttons": {
          "overview": "Aperçu des cartes",
          "sales": "Contacter les ventes",
          "admin": "Contacter l’admin"
        }
      }
    },
    "content": {
      "title": "Formulaire de contenu",
      "desc": "Trouvez ici l’aperçu de tous les nœuds sur la carte et son contenu.",
      "label": {
        "node": "Nœud",
        "title": "Titre",
        "type": "Type de boîte de contenu",
        "typeShort": "Boîte de contenu",
        "link": "Lien direct",
        "content": "Contenu",
        "info": "Informations supplémentaires",
        "nav": "Navigation sous la zone de contenu :",
        "prevNode": "Nœud précédent",
        "nextNode": "Nœud suivant",
        "terms": "Termes de recherche",
        "seo": "Description courte du contenu pour le SEO"
      },
      "placeholder": {
        "title": "Titre de la popup",
        "url": "Ajouter une URL",
        "terms": "Termes de recherche séparés par des virgules",
        "seo": "Ajoutez ici une description courte avec un maximum de 250 caractères."
      },
      "button": {
        "save": "Enregistrer le contenu du nœud",
        "translate": "Traduire avec DeepL",
        "discard": "Abandonner et quitter"
      },
      "message": {
        "error": "Une erreur s’est produite lors de la modification du contenu du nœud !",
        "unsaved": "Vous n’avez pas encore enregistré. Si vous n’enregistrez pas, vous perdrez vos modifications. Êtes-vous sûr de vouloir partir ?"
      },
      "sources": {
        "label": "Documents sources",
        "hint": "Le texte généré pour ce point s’appuie sur ces documents. Les lecteurs ne les voient jamais et ils ne sont jamais cités.",
        "none": "Aucun document n’est encore joint à ce point.",
        "attach": "Joindre un fichier",
        "attachLink": "Joindre un lien",
        "linkLabel": "Adresse de la page à joindre",
        "linkPlaceholder": "https://…",
        "addLink": "Joindre",
        "cancel": "Annuler",
        "remove": "Supprimer {name}",
        "confirmRemove": "Supprimer {name} ?",
        "delete": "Supprimer",
        "untitled": "Document joint",
        "reading": "Lecture du document…",
        "failed": "Ce document n’a pas pu être lu.",
        "fromDeletedPoint": "D’un point supprimé",
        "actionFailed": "Cela n’a pas fonctionné. Veuillez réessayer.",
        "unavailable": "Aucun LLM connecté. Demandez à un administrateur d'en connecter un dans les paramètres API pour utiliser des documents.",
        "title": "Documents sources de ce point",
        "close": "Fermer"
      }
    },
    "editors": {
      "title": "Note de l’éditeur",
      "desc": "Ajoutez des informations supplémentaires sur votre projet de carte via une note de l’éditeur.",
      "team": "Présentez les membres de votre équipe",
      "label": {
        "title": "Titre",
        "editors": "Note de l’éditeur",
        "name": "Nom",
        "desc": "Description",
        "label": "Étiquette",
        "togglerLabel": "Statut"
      },
      "placeholder": {
        "title": "ex. Note de l’éditeur et équipe",
        "desc": "Texte de description courte",
        "label": "Étiquette sur la carte"
      },
      "button": {
        "add": "Ajouter un membre d’équipe",
        "save": "Enregistrer la note de l’éditeur"
      },
      "message": {
        "errorLoading": "Une erreur s’est produite lors du chargement des paramètres !",
        "errorSave": "Une erreur s’est produite lors de la modification des paramètres !",
        "success": "Paramètres modifiés avec succès !"
      }
    },
    "glossary": {
      "title": "Glossaire",
      "desc": "Expliquez les termes sélectionnés de votre projet de carte, pour une meilleure compréhension.",
      "label": {
        "term": "Terme",
        "alternative": "Versions alternatives",
        "synonyms": "Synonymes",
        "definition": "Définition"
      },
      "placeholder": {
        "term": "Terme à définir",
        "alternative": "Séparé par des points-virgules ; n’apparaît pas dans la liste du glossaire",
        "synonyms": "Séparé par des points-virgules",
        "definition": "Texte de définition"
      },
      "button": {
        "add": "Ajouter de nouveaux termes",
        "save": "Enregistrer les paramètres du glossaire"
      },
      "message": {
        "errorLoading": "Une erreur s’est produite lors du chargement des paramètres du glossaire !",
        "errorSave": "Une erreur s’est produite lors de la modification des paramètres du glossaire !",
        "success": "Paramètres enregistrés avec succès !"
      }
    },
    "references": {
      "title": "Liste des références",
      "titleShort": "Sources",
      "desc": "Affichez les sources de votre recherche dans une liste de références",
      "label": {
        "name": "Nom de la source",
        "link": "Lien"
      },
      "placeholder": {
        "name": "Nom de la source",
        "link": "Référence à la source"
      },
      "button": {
        "add": "Ajouter une nouvelle source",
        "save": "Enregistrer la liste des sources",
        "upload": "Télécharger un fichier BibTeX"
      },
      "message": {
        "errorLoading": "Une erreur s’est produite lors du chargement des sources !",
        "errorSave": "Une erreur s’est produite lors de la modification de la liste des références !",
        "success": "Paramètres enregistrés avec succès !",
        "successFile": "Fichier téléchargé avec succès !",
        "errorFile": "Une erreur s’est produite lors du téléchargement du fichier !",
        "successFileProblems": "Fichier téléchargé. La carte affiche certaines références différemment du fichier – voir l’avertissement à côté."
      },
      "problems": {
        "summary": "La carte affiche {count} référence différemment du fichier : | La carte affiche {count} références différemment du fichier :",
        "missing_field": "{entry} : le champ « {field} » manque, la référence est donc affichée sous une forme abrégée",
        "empty": "{entry} : n’a ni titre, ni auteur, ni autre champ que la carte peut afficher, la référence est donc omise",
        "not_formatted": "{entry} : n’a pas pu être mise en forme, la référence est donc omise",
        "other": "{entry} : {message}",
        "more": "… et {count} autre | … et {count} autres",
        "unreadable": "Le fichier ne peut pas être lu, la carte n’affiche donc aucune référence. Veuillez télécharger un fichier corrigé. Détails : {message}"
      }
    },
    "header": {
      "title": "Barre d’en-tête",
      "desc": "Ajoutez une barre d’en-tête individuelle à votre projet de carte",
      "design": {
        "bg": "Arrière-plan",
        "height": "Hauteur de l’en-tête",
        "logo": "Logo",
        "logoHeight": "Hauteur du logo dans la barre d’en-tête",
        "link": "URL du lien du logo",
        "color": "Couleur de police"
      },
      "label": {
        "title": "Titre",
        "url": "URL",
        "target": "Fenêtre cible",
        "design": "Paramètres de design",
        "floating": "Liens flottants libres",
        "additional": "Liens supplémentaires"
      },
      "placeholder": {
        "title": "Titre visible",
        "url": "Veuillez saisir l’URL",
        "link": "URL du site web"
      },
      "options": {
        "new": "Nouvelle fenêtre",
        "same": "Même fenêtre / IFrame",
        "embed": "Fenêtre intégrant la carte"
      },
      "button": {
        "addAdditional": "Ajouter un lien supplémentaire",
        "addFloating": "Ajouter un lien flottant",
        "save": "Enregistrer les paramètres d’en-tête"
      },
      "message": {
        "success": "Paramètres modifiés avec succès !",
        "errorSave": "Une erreur s’est produite lors de la modification des paramètres de la barre d’en-tête !",
        "errorLoading": "Une erreur s’est produite lors du chargement des paramètres de la barre d’en-tête !",
        "warningRestore": "Vous êtes sur le point de restaurer la version de carte à la précédente. Êtes-vous sûr de vouloir continuer ?"
      }
    },
    "tableOfContent": {
      "title": "Table des matières",
      "desc": "Gérez ici toutes les parties de la table des matières",
      "subTitle": "Sous-catégories de la table des matières :",
      "label": {
        "show": "afficher",
        "individual": "ordre individuel"
      },
      "articles": {
        "desc1": "Déplacez l’article de la colonne de droite vers la ",
        "desc2": "colonne de gauche",
        "desc3": "et organisez-les par glisser-déposer. Vous pouvez créer jusqu’à quatre niveaux de hiérarchie.",
        "individual": "Ordre individuel de votre table des matières",
        "unsorted": "Articles non triés"
      }
    },
    "media": {
      "title": "Ressources média",
      "titleTemplates": "Modèles de média",
      "titleDetails": "Informations sur le fichier :",
      "label": {
        "templates": "Modèles de fichiers",
        "container": "Dans quel(s) conteneur(s) ce fichier sera-t-il affiché ?",
        "small": "Panneau latéral étroit",
        "wide": "Panneau latéral large",
        "detached": "Boîte de contenu détachée",
        "icon": "Icône de carte",
        "bg": "Image d’arrière-plan",
        "desc": "Qu’est-ce qui décrit le mieux votre fichier ?",
        "photo": "Photographie",
        "portrait": "Portrait",
        "graphic": "Infographie",
        "drawing": "Dessin",
        "illustration": "Illustration",
        "animation": "Animation",
        "film": "Film",
        "voice": "Voix",
        "music": "Musique",
        "author": "Auteur/Créateur",
        "title": "Titre",
        "contact": "Informations de contact",
        "copyright": "Copyright",
        "dateCreation": "Date de création",
        "authorText": "Texte pour la signature de l’auteur",
        "summary": "Résumé court",
        "keywords": "Mots-clés",
        "searchTerms": "Termes de recherche (mots-clés priorisés dans la recherche)",
        "datePublication": "Date de publication",
        "source": "Source",
        "categories": "Catégories (hiérarchie prédéfinie)"
      },
      "placeholder": {
        "author": "Ajouter un nom",
        "title": "Ajouter un titre",
        "contact": "Ajouter des informations",
        "copyright": "Ajouter un copyright",
        "dateCreation": "AAAA-MM-JJ HH:MM:SS",
        "authorText": "Tapez ici",
        "summary": "Tapez ici",
        "keywords": "Ajouter des mots-clés",
        "searchTerms": "Ajouter des termes de recherche",
        "voice": "Ajouter du texte",
        "datePublication": "AAAA-MM-JJ HH:MM:SS",
        "source": "Ajouter du texte",
        "categories": "Ajouter du texte",
        "categoriesTranslate": "Ajouter une traduction"
      },
      "button": {
        "upload": "Télécharger un nouveau fichier",
        "back": "Retour à l’aperçu",
        "copy": "copier l’URL du média",
        "update": "Mettre à jour les informations",
        "uploadFile": "Télécharger un fichier"
      },
      "message": {
        "errorUpload": "Quelque chose s’est mal passé !",
        "update": "Mis à jour avec succès",
        "paste": "URL de l’image choisie prête à coller",
        "errorLoading": "Quelque chose s’est mal passé. Veuillez réessayer !",
        "sizeExceeded": "Taille de fichier dépassée !",
        "invalidLottie": "Ce fichier JSON n'est pas une animation Lottie valide.",
        "categoryCreateError": "La catégorie n’a pas pu être créée."
      },
      "upload": {
        "overview": "Aperçu des tailles de fichier maximales",
        "fileLimit": "max {size}Mo par fichier.",
        "noLimit": "aucune limite",
        "video": "Fichiers vidéo",
        "videoOptimal": "Paramètres de fichier optimaux : Rendu avec format HEVC (H.265)",
        "images": "Images",
        "vector": "Format web basé sur des vecteurs",
        "audio": "Formats audio",
        "other": "Tous les autres fichiers"
      }
    },
    "mediaList": {
      "header": {
        "name": "Nom des fichiers",
        "check": "Vérification du fichier"
      },
      "message": {
        "accepted": "Prêt à télécharger",
        "denied": "La taille du fichier est trop importante.\n Ce fichier ne sera pas téléchargé."
      },
      "uploadButton": "Télécharger les fichiers"
    },
    "social": {
      "title": "Icônes de partage",
      "desc": "Choisissez votre menu de partage. Toutes les options sélectionnées apparaissent automatiquement comme boutons sur votre carte.",
      "message": {
        "errorLoading": "Une erreur s’est produite lors du chargement des paramètres de réseau social !",
        "errorSave": "Une erreur s’est produite lors de la modification des paramètres de réseau social !",
        "success": "Paramètres modifiés avec succès !"
      }
    },
    "cookie": {
      "title": "Consentement aux cookies",
      "desc": "Ajoutez un consentement aux cookies à votre projet de carte.",
      "label": {
        "activate": "Activer le consentement aux cookies",
        "essentialLabel": "Cookies nécessaires",
        "essentialDescription": "Description des cookies nécessaires",
        "externalLabel": "Autoriser les sources externes",
        "externalDescription": "Description des médias externes",
        "statisticsLabel": "Statistiques",
        "statisticsDescription": "Description des statistiques",
        "imprintLabel": "URL des mentions légales",
        "policyLabel": "URL de la politique de confidentialité"
      },
      "placeholder": {
        "link": "Liez votre propre politique de protection des données. Si vous le laissez vide, la politique standard de Kontextlab sera connectée."
      },
      "message": {
        "success": "Paramètres modifiés avec succès !",
        "errorLoading": "Une erreur s’est produite lors du chargement des paramètres de consentement aux cookies !",
        "errorSave": "Une erreur s’est produite lors de la modification des paramètres de consentement aux cookies !"
      }
    },
    "seo": {
      "title": "SEO",
      "desc": "Ajoutez une description supplémentaire à votre projet pour aider les moteurs de recherche à trouver votre projet.",
      "label": {
        "desc": "Description",
        "url": "URL pour les cartes intégrées"
      },
      "info": {
        "url1": "Pour l’optimisation des moteurs de recherche, il est important de choisir la bonne URL lors de la publication de la carte. Les URL disponibles peuvent être copiées depuis la page de publication.",
        "url2": "Cependant, il faut noter que l’intégration d’une telle URL via IFrame ou code d’intégration a un effet négatif sur l’optimisation des moteurs de recherche.",
        "url3": "Pour un résultat de recherche optimisé, utiliser le domaine original ou un domaine CNAME est la meilleure option."
      },
      "placeholder": {
        "desc": "Description courte de votre projet de carte. Idéalement 120 — 160 caractères.",
        "url": "URL de la page finale, où la carte sera intégrée"
      },
      "message": {
        "success": "Paramètres modifiés avec succès !",
        "errorLoading": "Une erreur s’est produite lors du chargement des paramètres seo !",
        "errorSave": "Une erreur s’est produite lors de la modification des paramètres seo !"
      }
    },
    "url": {
      "title": "URL spécifique à la carte",
      "desc": "Copiez l’URL du projet ou personnalisez-la avec un identifiant individuel.",
      "label": {
        "usage": "Utilisation sur",
        "usageSub": "Utilisation sur sous-domaine client",
        "usageCNAME": "Utilisation via URL CNAME",
        "url": "Identifiant URL"
      },
      "info": {
        "default": "Votre URL de carte par défaut",
        "personalized": "Votre URL de carte personnalisée",
        "manageSubdomain": "Vous pouvez gérer le sous-domaine de cette URL individuelle dans les",
        "customizeID": "Personnalisez l’identifiant URL individuel pour ce projet (c’est l’identifiant spécifique à la fin de l’URL).",
        "defaultID": "Le <span class=\"font-weight--500\">{id}</span> est utilisé ici comme identifiant par défaut :",
        "urlCustom": "La dernière partie de l’URL peut être personnalisée plus bas dans le champ \"Identifiant URL\"",
        "usageSub": "Comme alternative, variante d’URL plus courte, une URL spécifique au client peut également être utilisée, qui est fournie sur",
        "usageCNAME": "Les cartes publiques utilisent cette URL pour les optimiser pour les moteurs de recherche. Toutes les cartes qui ne doivent pas être publiques doivent utiliser une URL alternative pour utiliser la restriction d’accès.",
        "noSubdomain": {
          "createOptions": "Créez une URL individuelle et raccourcie pour votre carte. Selon le package, vous avez deux options :",
          "subdomain": "1. un sous-domaine kontextmaps individuel",
          "or": "ou",
          "cname": "2. un transfert de la carte vers votre propre domaine ou sous-domaine via CNAME.",
          "note": "Veuillez noter : Une seule de ces deux options peut être configurée à la fois. Les paramètres de domaine individuels s’appliquent à tous les projets de carte de votre compte. Configurez l’identifiant URL individuellement pour chaque projet de carte.",
          "noURL": "Il n’y a pas encore de paramètre d’URL individuel. Sélectionnez l’une des deux options dans les",
          "linkSettings": "paramètres de compte généraux",
          "setURL": "Vous pouvez alors définir l’identifiant URL individuel pour ce projet ici :"
        }
      },
      "placeholder": {
        "url": "Spécifiez une URL"
      },
      "message": {
        "success": "Paramètres modifiés avec succès !",
        "errorLoading": "Une erreur s’est produite lors du chargement des paramètres de détails d’url !",
        "errorSave": "Une erreur s’est produite lors de la modification des paramètres d’url de carte !",
        "paste": "Lien copié dans le presse-papiers !",
        "errorPaste": "Ne peut pas être copié dans le presse-papiers ! Veuillez le faire manuellement."
      }
    },
    "access": {
      "title": "Restriction d’accès",
      "desc": "Décidez si votre projet de carte est accessible au public ou seulement accessible à certains groupes.",
      "options": {
        "limited": "accès limité",
        "partial": "accès partiellement limité",
        "accessible": "accessible au public"
      },
      "label": {
        "access": "Restriction d’accès",
        "additional": "Restrictions supplémentaires",
        "callEmbedded": "Appelable uniquement lorsqu’intégré",
        "clickablePoints": "Nombre de points popup cliquables",
        "loginForm": "Texte pour le formulaire de connexion",
        "registerForm": "Texte pour le formulaire d’inscription",
        "consent": "Texte pour le consentement à l’inscription",
        "consentRequired": "Le consentement à l’inscription est requis",
        "allowEmbedded": "Autoriser les domaines intégrés"
      },
      "placeholder": {
        "allowEmbedded": "Un domaine ou sous-domaine par ligne, ex.\nexample.com ou kontext.example.com"
      },
      "message": {
        "success": "Paramètres modifiés avec succès !",
        "errorLoading": "Une erreur s’est produite lors du chargement des paramètres de restrictions d’accès !",
        "errorSave": "Une erreur s’est produite lors de la modification des paramètres de restrictions d’accès !"
      }
    },
    "embed": {
      "title": "Code d’intégration",
      "desc": "Intégrez votre projet de carte sur votre site web existant.",
      "label": {
        "iframe": "Pour intégrer la carte sur votre site web via iFrame, veuillez copier l’extrait de code complet suivant :",
        "preview": "Vous pouvez également intégrer la carte avec une image d’aperçu. L’image d’aperçu apparaîtra sur votre site web et si vous cliquez dessus, la carte s’ouvrira dans la fenêtre du navigateur. Pour cela, veuillez d’abord charger votre image d’aperçu dans la gestion des médias avec le nom d’image preview.jpg ou preview.png. Ensuite, copiez le code suivant et collez-le dans votre site web :"
      },
      "message": {
        "paste": "Lien copié dans le presse-papiers !",
        "errorLoading": "Une erreur s’est produite lors du chargement des paramètres de code d’intégration !",
        "errorPaste": "Ne peut pas être copié dans le presse-papiers ! Veuillez le faire manuellement."
      }
    },
    "general": {
      "title": "Paramètres généraux",
      "desc": "Modifiez le profil et les paramètres de domaine généraux.",
      "label": {
        "profile": "Profil",
        "company": "Nom de l’entreprise",
        "logo": "Logo",
        "logoText": "Texte de la page de connexion",
        "domain": "Paramètres de domaine",
        "cname": "Domaine CNAME",
        "subdomain": "Votre sous-domaine KontextMaps"
      },
      "info": {
        "settings": "Gérez ici votre domaine principal individuel et raccourci, qui s’applique à toutes vos publications de cartes.",
        "settingsNote": "Veuillez noter : Une seule de ces deux options peut être configurée à la fois.",
        "cname": "Créez un sous-domaine individuel sur le système de votre hébergeur web et définissez les paramètres de domaine sur CNAME et permettez à Kontextlab l’accès.",
        "subdomain": "Sachez que la modification du sous-domaine va briser les URL déjà partagées, les invalidant pour une utilisation future."
      },
      "placeholder": {
        "company": "Nom",
        "cname": "Ajoutez votre domaine connecté CNAME individuel ex. cname.com",
        "subdomain": "ex. sous-domaine"
      },
      "button": {
        "upload": "Télécharger un portrait"
      },
      "message": {
        "success": "Paramètres modifiés avec succès !",
        "errorLoading": "Une erreur s’est produite lors du chargement des paramètres de domaine généraux !",
        "errorSave": "Une erreur s’est produite lors de la modification des paramètres de domaine généraux !"
      }
    },
    "profile": {
      "title": "Profil",
      "desc": "Gérez votre profil individuel.",
      "label": {
        "firstName": "Prénom",
        "surname": "Nom de famille",
        "email": "Adresse email",
        "picture": "Photo de profil"
      },
      "placeholder": {
        "firstName": "Prénom",
        "surname": "Nom",
        "email": "Adresse email"
      },
      "button": {
        "upload": "Télécharger un portrait"
      },
      "message": {
        "success": "Profil modifié avec succès !",
        "errorSave": "Une erreur s’est produite lors de la modification des paramètres de profil !"
      }
    },
    "password": {
      "title": "Mot de passe",
      "desc": "Gérez votre mot de passe.",
      "label": {
        "password": "Mot de passe",
        "confirm": "Confirmation du mot de passe"
      },
      "placeholder": {
        "password": "Au moins 8 caractères",
        "confirm": "Confirmez votre mot de passe"
      },
      "message": {
        "success": "Mot de passe modifié avec succès !",
        "errorSave": "Quelque chose s’est mal passé"
      }
    },
    "mapGeneral": {
      "title": "Paramètres généraux de la carte",
      "desc": "Gérez les informations générales de votre projet de carte.",
      "settingsTitle": "Paramètres individuels pour la vue de carte en direct",
      "label": {
        "project": "Nom du projet de carte",
        "desc": "Description",
        "terms": "Termes de recherche",
        "section": "Section",
        "palette": "Palette de couleurs",
        "preview": "Image d’aperçu",
        "favicon": "Favicon",
        "premium": "Modèle premium",
        "templateDescription": "Description courte du modèle",
        "templateDescriptionUrl": "URL vers la description détaillée du modèle (optionnel)",
        "templateCategory": "Catégorie du modèle"
      },
      "placeholder": {
        "project": "Nom de la carte",
        "desc": "Description courte du contenu de la carte",
        "terms": "Termes de recherche séparés par des virgules",
        "section": "ex. affaires",
        "palette": "ex. océan",
        "templateDescription": "Description courte du modèle de carte, max 150 caractères",
        "templateDescriptionUrl": "URL vers la description externe du modèle"
      },
      "message": {
        "success": "Paramètres modifiés avec succès !",
        "errorSave": "Une erreur s’est produite lors de la modification des paramètres généraux de la carte !"
      },
      "button": {
        "favicon": "Télécharger un favicon",
        "preview": "Télécharger un aperçu"
      },
      "uploadDescription": {
        "notes": "Notes pour le téléchargement d’image favicon :",
        "dimensions": "Dimension d’image : carrée",
        "size": "Taille d’image : entre 128x128px et 512x512px",
        "format": "Format de fichier : .jpg ou .png"
      }
    },
    "mapVersion": {
      "title": "Version en direct",
      "titleProgress": "Carte en cours",
      "label": {
        "publish": "Publiez la version la plus récente ici.",
        "lastPublished": "Dernière modification le",
        "notPublished": "Version en direct pas encore publiée",
        "changed": "La carte a changé.",
        "lastLive": "Dernière version en direct publiée le"
      },
      "button": {
        "viewProgress": "Voir la carte en cours",
        "reset": "Réinitialiser le progrès de la carte",
        "sync": "Synchroniser avec la version en direct",
        "viewLive": "Voir la version en direct"
      },
      "message": {
        "successPublished": "Carte publiée avec succès !",
        "errorPublished": "Une erreur s’est produite lors de la publication de la carte !",
        "successReset": "Carte réinitialisée avec succès !",
        "errorReset": "Une erreur s’est produite lors de la réinitialisation de la carte !"
      }
    },
    "publishing": {
      "title": "Publiez votre carte",
      "desc": "Trouvez ici un guide étape par étape pour publier et partager votre carte",
      "tooltip": "Aperçu de publication",
      "blockedOptionTooltip": "La carte en direct est obligatoire pour modifier ces options.",
      "steps": {
        "create": {
          "title": "Créer une version en direct",
          "description": "Pour publier votre carte, vous devez créer une version en direct. Cette version est différente de la version d’aperçu : elle ne contient pas d’étiquette \"aperçu\" et n’affichera tous les changements ultérieurs que lorsque vous les téléchargerez activement là-bas. Vous pouvez gérer les versions de votre carte ",
          "descriptionLink": "ici.",
          "status": {
            "notPublished": "Ce projet de carte n’a pas encore de version en direct. Créez maintenant une version en direct de ce projet pour procéder à la publication.",
            "hasChanges": {
              "changes": "Une version en direct existe pour ce projet de carte. Cependant, des modifications ont été apportées.",
              "check": "Veuillez vérifier ",
              "link": "Versions de carte",
              "upload": "pour voir si vous voulez télécharger ces modifications vers la version en direct actuelle.",
              "access": "Ou continuez avec la ",
              "accessLink": "gestion d’accès."
            },
            "exist": "Une version en direct existe pour ce projet de carte. La carte en direct est à jour.",
            "existLink": "Gérez maintenant l’accès pour cette carte."
          },
          "popup": {
            "noLiveVersionTitle": "Aucune version en direct disponible",
            "studentContent": "Pour publier le projet de carte, une version en direct est obligatoire. Celle-ci ne peut être créée que par des administrateurs ou des éditeurs. Veuillez donc contacter votre admin pour obtenir une URL valide."
          },
          "button": {
            "publish": "Publier comme version en direct"
          }
        },
        "access": {
          "title": "Gérer l’accès",
          "descStudent": "Les administrateurs peuvent décider si la carte en direct est accessible au public ou seulement à un groupe sélectionné.",
          "projectAccess": "Ce projet a actuellement"
        },
        "publish": {
          "title": "Publiez votre carte",
          "desc": "Choisissez l’une des trois options pour partager et publier votre carte :",
          "options": {
            "default": {
              "title": "1. L’URL par défaut",
              "desc": "Chaque carte reçoit automatiquement une URL. Celle-ci est toujours valide, quel que soit les autres options. Si votre carte n’est pas publique, les visiteurs invités doivent se connecter via une page de connexion pour accéder à la carte.",
              "url": "Votre URL par défaut :"
            },
            "custom": {
              "title": "2. Votre domaine personnalisé",
              "descAdmin": "Pour raccourcir l’URL et lui attribuer un identifiant unique, vous pouvez soit configurer un sous-domaine KontextMaps individuel, soit transférer la carte via domaine CNAME vers votre domaine personnel.",
              "admin": {
                "manage": "Gérez le",
                "subdomain": "sous-domaine ici",
                "and": "et l’",
                "id": "identifiant de carte ici."
              },
              "descStudent": "Pour rendre l’URL plus courte et lui attribuer un identifiant unique, un administrateur peut configurer un domaine individuel. Si vous voulez faire des modifications, ",
              "descStudentLink": "veuillez demander à votre admin.",
              "url": "L’URL individuelle de la carte est :",
              "noUrl": "Actuellement, aucun domaine individuel n’est configuré."
            },
            "embed": {
              "title": "3. Intégrer dans votre site web",
              "desc": "Intégrez la carte directement dans votre site web en utilisant un iFrame. Alternativement, vous pouvez inclure une image d’aperçu (choisissez la variante div tag pour cela), sur laquelle la carte s’ouvre en format complet avec un clic.",
              "link": "Trouvez tous les codes d’intégration ici."
            }
          }
        }
      }
    },
    "mapLanguages": {
      "title": "Paramètres de langue de la carte",
      "desc": "Gérez les paramètres de langue de cette carte et trouvez un aperçu de toutes les traductions.",
      "preview": {
        "title": "Paramètres de langue pour l’aperçu et la carte en direct",
        "radio": {
          "auto": "automatique (comme la langue du navigateur)",
          "default": "langue par défaut"
        },
        "label": {
          "first": "Quelle langue devrait être affichée en premier ?",
          "default": "Quelle est la langue par défaut ?",
          "additional": "Quelles langues supplémentaires voulez-vous ajouter ?",
          "translateWith": "Traduire avec",
          "integration": "Sélectionner l’intégration de traduction",
          "apiKey": "Votre clé API"
        },
        "placeholder": {
          "additional": "Langues supplémentaires",
          "provider": "Fournisseurs de traduction..",
          "apiKey": "Enregistré; laisser vide pour conserver la clé actuelle"
        }
      },
      "button": {
        "globalTranslation": "Traduire toute la carte"
      },
      "tooltip": {
        "translated": "Tous les textes traduits",
        "notTranslated": "Tous ou certains textes ne sont pas encore traduits. Veuillez vérifier les traductions.",
        "notTranslatedDefault": "Les étiquettes par défaut ne sont disponibles qu’en anglais. Veuillez ajouter des traductions pour la langue par défaut."
      },
      "message": {
        "targetLanguagesError": "Les langues supplémentaires {languages} ne sont pas supportées par DeepL. Veuillez vous assurer de les traduire manuellement.",
        "targetLanguageError": "La langue supplémentaire {language} n’est pas supportée par DeepL. Veuillez vous assurer de la traduire manuellement.",
        "partialTargetLanguagesError": "{languages} des langues supplémentaires ne sont pas supportées par DeepL. Veuillez vous assurer de les traduire manuellement.",
        "partialTargetLanguageError": "{language} des langues supplémentaires n’est pas supportée par DeepL. Veuillez vous assurer de la traduire manuellement.",
        "sourceLanguageError": "La langue {language} n’est pas supportée par DeepL",
        "credentialsError": "Veuillez vérifier vos identifiants ou réessayez plus tard."
      }
    },
    "mapProtocol": {
      "title": "Révisions",
      "desc": "Trouvez ici tous les derniers changements de votre projet de carte et restaurez les états précédents si nécessaire.",
      "label": {
        "version": "ID de version",
        "date": "Date",
        "time": "Heure",
        "editedBy": "Modifié par",
        "typeOfChange": "Type de changement",
        "restoreState": "Restaurer la version"
      }
    },
    "collectedVersions": {
      "title": "Versions collectées",
      "save": "Enregistrer l’état actuel de la carte",
      "publishLive": "Publier la version comme version en direct",
      "label": {
        "version": "ID de version",
        "date": "Date",
        "time": "Heure",
        "saved": "Enregistré par",
        "name": "Nom de la version",
        "describe": "Décrire l’état de la carte"
      },
      "message": {
        "error": "Une erreur s’est produite"
      }
    },
    "mapSpecific": {
      "access": {
        "none": "Aucun accès",
        "read": "Lecture",
        "edit": "Lecture et modification"
      },
      "button": {
        "save": "Enregistrer les paramètres de la carte"
      }
    },
    "user": {
      "title": "Comptes utilisateur",
      "desc": "Gérez tous les utilisateurs de vos projets de carte.",
      "label": {
        "name": "Nom complet",
        "email": "Adresse email",
        "role": "Rôle",
        "password": "Mot de passe",
        "passwordConfirm": "Confirmation du mot de passe",
        "premium": "Ceci est un modèle premium"
      },
      "placeholder": {
        "name": "Ajouter un nom",
        "email": "Ajouter une adresse email",
        "password": "Au moins 8 caractères",
        "passwordConfirm": "Confirmez votre mot de passe"
      },
      "button": {
        "add": "Ajouter un nouvel utilisateur",
        "save": "Enregistrer les paramètres utilisateur",
        "remove": "Supprimer l’utilisateur",
        "removeCancel": "J’ai changé d’avis"
      },
      "support": {
        "desc": "Gérer l’accès pour l’équipe de support KontextMaps",
        "checkbox": "J’accorde à l’équipe de support l’accès à mon compte et projets afin d’obtenir de l’aide"
      },
      "message": {
        "removeUser": "Continuer à supprimer l’utilisateur ?",
        "inviteAll": "Veuillez inviter tous les utilisateurs avant d’enregistrer",
        "success": "Comptes utilisateur modifiés avec succès !",
        "errorSave": "Une erreur s’est produite lors de la modification des paramètres de comptes utilisateur !",
        "errorLoading": "Une erreur s’est produite lors du chargement des paramètres de comptes utilisateur !",
        "emailExists": "Un mot de passe existe déjà pour cette adresse email. Si vous en saisissez un nouveau, il sera automatiquement utilisé pour tous les autres comptes connectés à cette adresse email.",
        "quotaReached": "Vous avez atteint la limite de places disponibles. Pour l’étendre, veuillez choisir le bon package."
      }
    },
    "analytics": {
      "title": "Paramètres d’analyse",
      "desc": "Connectez la carte à votre compte d’analyse.",
      "label": {
        "code": "Code d’analyse"
      },
      "placeholder": {
        "code": "ID de propriété Google"
      },
      "message": {
        "success": "Comptes utilisateur modifiés avec succès !",
        "errorSave": "Une erreur s’est produite lors de la modification des paramètres d’analyse !",
        "errorLoading": "Une erreur s’est produite lors du chargement des paramètres d’analyse !"
      }
    },
    "api": {
      "title": "Gérer l’API",
      "desc": "Connectez des sources externes avec votre compte KontextMap.",
      "label": {
        "key": "Clé API",
        "address": "Adresse du serveur"
      },
      "placeholder": {
        "key": "Saisissez ici votre clé API",
        "address": "Saisissez ici l’adresse du serveur",
        "keyStored": "Enregistré – saisissez une nouvelle valeur pour le remplacer"
      },
      "button": {
        "save": "Enregistrer les paramètres API",
        "test": "Tester la connexion"
      },
      "ownModel": {
        "title": "LLM personnel",
        "desc": "Connectez votre propre modèle de langage pour générer le contenu des articles des points.",
        "noneOption": "Non connecté",
        "label": {
          "provider": "Fournisseur",
          "model": "Modèle",
          "endpoint": "Point de terminaison",
          "apiVersion": "Version de l'API",
          "key": "Clé API"
        },
        "placeholder": {
          "provider": "Sélectionnez un fournisseur",
          "model": "p. ex. gpt-4o, mistral-large-latest",
          "endpoint": "URL de base du serveur",
          "apiVersion": "p. ex. 2024-10-21",
          "key": "Saisissez la clé API du fournisseur",
          "keyOptional": "Facultatif pour les serveurs sur site"
        },
        "button": {
          "save": "Enregistrer les paramètres LLM"
        }
      },
      "field": {
        "api_key": "Clé API",
        "api_token": "Jeton d’API",
        "client_id": "ID de l’application (client)",
        "client_secret": "Secret client",
        "deployment": "Déploiement",
        "email": "E-mail du compte",
        "integration_token": "Jeton d’intégration interne",
        "permission_scope": "Portée des autorisations",
        "server_url": "Adresse du serveur",
        "site_url": "URL du site",
        "space_key": "Clé de l’espace",
        "tenant_id": "ID de l’annuaire (locataire)"
      },
      "fieldPlaceholder": {
        "email": "bot{'@'}entreprise.fr",
        "site_url": "https://entreprise.sharepoint.com/sites/technique",
        "space_key": "p. ex. TECHNIQUE"
      },
      "help": {
        "api_token": "Cloud : un jeton d’API Atlassian. Data Center : un jeton d’accès personnel.",
        "client_id": "Entra ID → Inscriptions d’applications → ton application → Vue d’ensemble → ID d’application (client). L’inscription a besoin de l’autorisation d’application choisie ci-dessous, avec consentement administrateur.",
        "client_secret": "Entra ID → Inscriptions d’applications → ton application → Certificats et secrets → Nouveau secret client. Copie la Valeur, pas l’ID du secret. SharePoint lui-même n’a pas de clé d’API.",
        "email": "Le compte Atlassian auquel appartient le jeton d’API.",
        "integration_token": "Crée une intégration interne sur notion.so/my-integrations et colle son secret ici. Ensuite, dans Notion, partage chaque page à proposer avec cette intégration via le menu de la page, sous « Connexions » : **un jeton valide n’affiche rien tant que rien ne lui a été partagé.**",
        "permission_scope": "Sites.Read.All autorise cette application à lire **tous les sites du locataire**, pas seulement celui configuré ici — l’URL du site limite ce que cette connexion affiche, pas ce que l’application peut lire. Sites.Selected n’accorde rien par défaut : un administrateur SharePoint accorde ensuite l’accès en lecture site par site. À préférer, sauf si la recherche sur un grand site est nécessaire — elle lit le site directement, sans l’index de recherche du locataire et sans nombre de résultats.",
        "site_url": "Le site à lire, p. ex. https://acme.sharepoint.com/sites/engineering — l’adresse du site lui-même, pas celle d’une page.",
        "space_key": "Seules les pages de cet espace sont proposées. La clé est le code court de l’URL de l’espace, p. ex. /wiki/spaces/ENG — ce n’est pas un jeton d’API.",
        "tenant_id": "Entra ID → Inscriptions d’applications → ton application → Vue d’ensemble → ID de l’annuaire (locataire)."
      },
      "choice": {
        "deployment": {
          "cloud": "Atlassian Cloud",
          "datacenter": "Data Center / Serveur (auto-hébergé)"
        },
        "permission_scope": {
          "sites_read_all": "Sites.Read.All — tous les sites du locataire",
          "sites_selected": "Sites.Selected — uniquement les sites autorisés un à un"
        }
      },
      "noneEnabled": "Aucune source externe n’a encore été activée pour ce compte.",
      "message": {
        "incomplete": "{provider} n’a pas été enregistré : renseigne {fields}.",
        "looksLikeSecret": "{provider} n’a pas été enregistré : « {field} » semble contenir un jeton d’API. Le jeton va dans le champ d’identifiants de cette source.",
        "testRunning": "Test de la connexion…",
        "testTotal": "Connecté — {total} éléments disponibles.",
        "testSome": "Connecté — du contenu a été renvoyé.",
        "testEmpty": "Connecté, mais la source ne renvoie rien. Vérifie la clé d’espace ou l’URL du site.",
        "testSample": "Premier élément : « {title} ».",
        "testNotEnabled": "Les identifiants fonctionnent. {provider} doit encore être activé pour ce compte avant d’apparaître dans le Map Builder.",
        "testFailed": "Le test a échoué."
      },
      "connection": {
        "label": "Nom de la connexion",
        "placeholder": "p. ex. Wiki technique",
        "add": "Ajouter une connexion",
        "create": "Ajouter la connexion",
        "save": "Enregistrer la connexion",
        "cancel": "Annuler",
        "remove": "Déconnecter",
        "removeConfirm": "Déconnecter définitivement",
        "removeHint": "Les contenus déjà intégrés depuis cette connexion ne seront plus résolus, et le nom n’est jamais réutilisé.",
        "labelRequired": "Donne un nom à la connexion : c’est la seule chose qui distingue deux connexions d’une même source.",
        "added": "« {label} » a été ajouté à {provider}.",
        "saved": "« {label} » a été enregistré.",
        "removed": "« {label} » a été déconnecté de {provider}.",
        "perConnection": "Chaque connexion de cette source est enregistrée séparément."
      },
      "assistant": {
        "title": "Assistant KAIA",
        "desc": "KAIA accompagne les auteurs dans la construction d’une carte. Désactivé, il disparaît de toutes les cartes de ce compte ; un auteur peut aussi le désactiver pour une seule carte dans ses paramètres généraux.",
        "label": "Activer KAIA pour ce compte"
      }
    },
    "reports": {
      "title": "Rapports d’analyse",
      "desc": "Connectez la carte à votre compte d’analyse."
    },
    "invoices": {
      "title": "Factures",
      "desc": "Trouvez ici une liste de vos factures.",
      "message": {
        "errorLoading": "Une erreur s’est produite lors du chargement des détails de factures !"
      }
    },
    "billing": {
      "title": "Données de facturation",
      "desc": "Mettez à jour les données pour votre facture ici.",
      "label": {
        "company": "Nom de l’entreprise",
        "email": "Adresse email",
        "address": "Adresse",
        "postal": "Code postal",
        "city": "Ville",
        "state": "État",
        "country": "Pays",
        "id": "Numéro d’identification TVA"
      },
      "placeholder": {
        "company": "Nom",
        "email": "Ajouter une adresse email",
        "address": "Nom de la rue",
        "postal": "12345",
        "city": "Nom de la ville",
        "state": "Nom de l’état",
        "id": "DE123456789"
      },
      "message": {
        "success": "Paramètres modifiés avec succès !",
        "errorSave": "Une erreur s’est produite lors de la modification des paramètres de facturation !",
        "errorLoading": "Une erreur s’est produite lors du chargement des paramètres de facturation !"
      }
    },
    "subscription": {
      "title": "Gérer l’abonnement",
      "desc": "Aperçu de votre licence actuelle",
      "overview": {
        "plan": "Votre plan actuel :",
        "extension": "Vos extensions de plan :",
        "start": "Votre licence a commencé le :",
        "renew": "Votre licence sera automatiquement renouvelée le :"
      },
      "manage": {
        "title": "Gérer la licence actuelle et les données associées",
        "desc": "Veuillez accéder au portail de libre-service de notre fournisseur de paiement afin de :",
        "list": {
          "adjust": "Ajuster vos données de facture",
          "manage": "Gérer les données de paiement",
          "cancel": "Annuler la licence"
        },
        "button": "Accéder au portail de libre-service"
      },
      "order": {
        "title": "Commander des extensions",
        "desc": "Veuillez choisir parmi les options suivantes pour mettre à niveau votre licence. La facturation (annuelle/mensuelle) suit la période de facturation de votre licence principale.",
        "extension": {
          "mapCreator": "Créateur de carte supplémentaire (admin ou éditeur)",
          "liveMap": "Carte en direct supplémentaire",
          "storage": "Stockage média supplémentaire de 5Go"
        },
        "month": "mois",
        "button": "Acheter l’extension"
      },
      "confirm": {
        "title": "Vous êtes sur le point d’acheter les extensions de licence suivantes :",
        "desc": {
          "restart": "Avec l’achat des extensions, la durée de votre licence redémarre aujourd’hui :",
          "license": "Par conséquent, en plus des extensions, la licence de votre licence actuelle sera également recalculée. Les frais de licence déjà payés de la durée restante d’origine seront déduits du montant total."
        },
        "total": {
          "period": "Période de facturation :",
          "extension": "Extension de licence totale,",
          "plan": "Plan de licence total (nom du plan),",
          "term": "Moins la durée restante de la licence actuelle"
        },
        "period": {
          "month": "mensuel",
          "year": "annuel"
        },
        "invoice": "Ainsi, le montant total de la facture est :",
        "button": "Mettre à niveau le plan"
      }
    },
    "payment": {
      "title": "Paramètres de paiement",
      "desc": "Gérez votre méthode de paiement."
    },
    "release": {
      "message": {
        "errorLoading": "Erreur lors du chargement des notes de version !"
      }
    },
    "manual": {
      "sidebar": {
        "title": "Aide",
        "types": {
          "tour": "Visite du Map Builder",
          "manual": "Manuel utilisateur"
        }
      },
      "content": {
        "title": "Guides utilisateur",
        "description": "Sélectionnez l’un des guides pour en savoir plus sur le Map Builder",
        "list": {
          "basicTour": {
            "title": "Visite basique du Map Builder",
            "description": "Un guide rapide et court à travers les fonctionnalités les plus importantes"
          },
          "basicStudentTour": {
            "title": "Voyage rapide à travers les fonctions :",
            "description": "Une introduction courte pour d’excellentes cartes de connaissances"
          },
          "baseKnowledge": {
            "title": "Base de connaissances",
            "description": "Un aperçu complet et exhaustif de toutes les fonctions."
          }
        }
      }
    },
    "quizzes": {
      "title": "Outil de quiz",
      "description": "Créer et gérer ce quiz",
      "createQuiz": "Créer un nouveau quiz",
      "label": {
        "name": "Nom du quiz",
        "description": "Optionnel : Description",
        "picture": "Optionnel : Image de titre au-dessus des questions"
      },
      "placeholder": {
        "name": "Donnez un nom au quiz",
        "description": "Optionnel : Description courte du quiz"
      },
      "checkbox": {
        "expandableList": "Les questions sont présentées dans une liste extensible",
        "correctAnswer": "Réponse",
        "multipleAnswers": "Réponses multiples"
      },
      "button": {
        "upload": "Télécharger l’image de titre",
        "back": "Retour à l’aperçu",
        "add": "Ajouter une question",
        "save": "Enregistrer le quiz",
        "addAnswer": "Ajouter une réponse"
      },
      "section": {
        "questions": "Ajouter des questions et réponses"
      }
    },
    "link": {
      "title": "Insérer un lien",
      "edit": "Modifier le lien",
      "url": "URL",
      "urlPlaceholder": "https://… ou #p=12",
      "or": "ou",
      "text": "Texte du lien",
      "newWindow": "Ouvrir dans une nouvelle fenêtre",
      "chooseOnMap": "Choisir sur la carte",
      "apply": "Appliquer",
      "remove": "Supprimer le lien",
      "cancel": "Annuler",
      "pickerTitle": "Choisir une cible sur la carte",
      "pickerHint": "Déplacez la carte pour choisir une zone, ou ouvrez un nœud pour y renvoyer directement.",
      "pickerNodeHint": "Fermez le nœud ouvert pour renvoyer plutôt vers une zone.",
      "pickerNode": "Nœud {id}",
      "pickerArea": "Zone sur le calque {layer}",
      "pickerEmpty": "Rien de choisi pour l’instant",
      "pickerUse": "Utiliser ce lien",
      "pickerBlocked": "La carte ne peut pas être affichée ici. Choisissez plutôt un nœud dans la liste.",
      "pickerNodeFallback": "Nœud"
    },
    "external": {
      "title": "Connecter du contenu externe de",
      "connectTitle": "Connexion à :",
      "tooltip": "Contenu externe",
      "search": "Rechercher",
      "searchPlaceholder": "Rechercher dans cette source …",
      "shown": "{shown} sur {total} affichés",
      "noResults": "Aucun résultat.",
      "loadMore": "Afficher plus",
      "shownUnknownTotal": "{shown} affichés",
      "retry": "Réessayer",
      "emptyIn": "0 élément trouvé dans {source}.",
      "error": {
        "network": "Serveur injoignable. Vérifie ta connexion et réessaie.",
        "notFound": "{source} n’est pas connecté à ce compte.",
        "rateLimited": "{source} limite les requêtes. Patiente un instant et réessaie.",
        "generic": "{source} n’a pas pu être chargé (HTTP {status}). {detail}",
        "session": "Ta session a expiré. Reconnecte-toi pour continuer.",
        "notEntitled": "{source} n’est pas activé pour ce compte. La source doit d’abord être activée.",
        "forbidden": "Tu n’as pas accès aux sources externes de ce compte.",
        "configuration": "{source} n’est pas encore configuré. Renseigne ses identifiants dans Paramètres du compte, Manage API.",
        "configurationField": "{source} n’est pas configuré correctement : vérifie « {field} » dans Paramètres du compte, Manage API.",
        "connectionGone": "Cette connexion à {source} n’existe plus. Choisis-en une autre.",
        "upstream": "{source} est en échec ou a refusé les identifiants enregistrés. Vérifie la connexion dans Paramètres du compte, Manage API."
      },
      "signIn": "Se reconnecter",
      "connection": "Connexion",
      "frameSource": "Source : {source}",
      "type": {
        "livedoc": "Live Doc"
      },
      "message": {
        "livedocBlocked": "Un Live Doc Confluence ne peut pas être intégré. Choisis une page classique ou convertis-la dans Confluence."
      },
      "view": {
        "tiles": "Vignettes",
        "list": "Liste",
        "folders": "Dossiers"
      }
    }
  },
  "tour": {
    "steps": {
      "welcome": {
        "title": "Bienvenue dans le Map Builder !",
        "description": "Veuillez suivre cette visite pour apprendre les bases de la création de cartes de connaissances magnifiquement conçues et convaincantes."
      },
      "newProject": {
        "title": "Démarrer un nouveau projet",
        "description": "Commencez à partir de zéro ou utilisez un modèle de carte"
      },
      "structure": {
        "title": "Construire la structure",
        "description": "Ajoutez des nœuds et dessinez des connexions"
      },
      "design": {
        "title": "Appliquez votre design",
        "description": "Utilisez des modèles pour concevoir les éléments ou appliquez votre design individuel"
      },
      "content": {
        "title": "Ajouter du contenu",
        "description": "Textes, photos, vidéos, graphiques — fournissez des informations approfondies pour chaque aspect."
      },
      "layers": {
        "title": "Créer une expérience d’exploration approfondie",
        "description": "Ajoutez des calques et ajustez la visibilité des nœuds sur différents calques"
      },
      "publish": {
        "title": "Publier et partager votre projet de carte",
        "description": "Choisissez les restrictions d’accès et l’une des nombreuses façons de partager votre carte."
      }
    },
    "stepsStudent": {
      "welcome": {
        "title": "Bienvenue et c’est bien que tu sois là !",
        "description": "Cette visite te montre de façon courte et percutante, comme il est simple de créer de magnifiques cartes de connaissances."
      },
      "newProject": {
        "title": "Démarre un nouveau projet",
        "description": "Démarre ton propre projet de carte ou utilise le modèle de ton professeur."
      },
      "points": {
        "title": "Dessine des points",
        "description": "Crée de nouveaux points et donne-leur un design."
      },
      "connections": {
        "title": "Montre comment tout est connecté",
        "description": "Dessine des connexions entre les points."
      },
      "explanations": {
        "title": "Explique chaque point",
        "description": "Textes, photos, vidéos - ajoute du contenu qui explique le point."
      },
      "map": {
        "title": "Crée une carte pour s’immerger !",
        "description": "Ajoute des calques et règle la visibilité des points."
      },
      "simultaneous": {
        "title": "Travaille avec ton groupe ensemble",
        "description": "Modifie ta carte de connaissances ensemble avec tes camarades de classe."
      },
      "publish": {
        "title": "Publie ta carte de connaissances",
        "description": "Mets la carte en direct pour la présentation."
      }
    },
    "control": {
      "skip": "Passer",
      "back": "Retour",
      "next": "Suivant",
      "start": "Commençons"
    }
  },
  "tinymce": {
    "expandableList": "Liste extensible",
    "expandableTitle": "Titre extensible",
    "expandableContent": "Contenu extensible"
  },
  "multiSelection": {
    "selected": "sélectionnés",
    "delete": "Supprimer",
    "deselect": "Tout désélectionner"
  },
  "kaia": {
    "trigger": {
      "label": "Discuter avec KAIA",
      "blockedBy": "{name} utilise KAIA en ce moment",
      "blocked": "KAIA est actuellement utilisée par quelqu'un d'autre"
    },
    "header": {
      "phaseLabel": "Phase {index}/{total} — {name}",
      "verified": "vérifié",
      "inProgress": "en cours",
      "close": "Fermer",
      "settings": "Paramètres de la carte : activer ou désactiver KAIA pour cette carte"
    },
    "phases": {
      "onboarding": "Onboarding",
      "sensemaking": "Sensemaking",
      "categoryFormation": "Formation des catégories",
      "structureChoice": "Choix de la structure",
      "relevanceConstruction": "Construction de la pertinence",
      "layering": "Niveaux",
      "designContent": "Design et contenu",
      "wayfinding": "Orientation"
    },
    "overview": {
      "title": "KAIA – Assistant IA Kontext",
      "description": "KAIA te guide à travers notre processus éprouvé en 7 phases pour construire une KontextMap complète et compréhensible.",
      "verified": "Terminé et vérifié avec succès",
      "inProgress": "En cours",
      "pending": "En attente",
      "phaseName": "Phase {index} {name}",
      "jump": "Aller à cette phase"
    },
    "validation": {
      "title": "VALIDATION DE LA PHASE {phase}",
      "confirm": "Confirmer",
      "edit": "Modifier"
    },
    "review": {
      "refine": "Améliorer mes réponses"
    },
    "input": {
      "answer": "Écris ta réponse …",
      "question": "Écris ta question …",
      "uploadUrl": "Colle un lien, ou joins un fichier"
    },
    "mock": {
      "onboarding": {
        "greeting": "Bonjour ! Je suis KAIA, ton assistant IA pour ta KontextMap. Je te guide pas à pas tout au long du processus – nous construisons ta carte directement ici dans le Map Builder. Chaque décision devient immédiatement visible sur le canevas. Souhaites-tu mon aide, ou préfères-tu commencer par toi-même ?",
        "greetingQuestion": "Souhaites-tu mon aide, ou préfères-tu commencer par toi-même ?",
        "optHelp": "Je voudrais ton aide",
        "optOwn": "Je préfère travailler seul",
        "standBack": "Très bien, je me retire. Tu peux m'appeler à tout moment."
      },
      "phase1": {
        "topic": "Quel sujet ta KontextMap doit-elle couvrir ? Décris-le en une à trois phrases.",
        "topicQ": "Quel sujet ta KontextMap doit-elle couvrir ?",
        "purpose": {
          "km": "Gestion des connaissances & documentation",
          "science": "Science & recherche",
          "comm": "Communication & orientation",
          "strategy": "Stratégie & changement",
          "education": "Éducation & formation",
          "other": "J'ai un autre objectif"
        },
        "start": {
          "expertise": "Nous avons l'expertise dans l'équipe et voulons la structurer",
          "content": "Nous avons du contenu existant (étude, rapport) à présenter visuellement",
          "regulation": "Nous devons expliquer un ensemble de règles à notre public",
          "research": "Le sujet doit d'abord être étudié"
        },
        "uploadOffer": "Téléverse ton document et je l'analyse.",
        "analyzing": "J'analyse le fichier …",
        "analyzed": "Terminé.",
        "goal": "Que doivent comprendre ou pouvoir faire les utilisateurs de ta carte après l'avoir utilisée ?",
        "goalQ": "Que doivent comprendre ou pouvoir faire les utilisateurs de ta carte après l'avoir utilisée ?",
        "goalExamples": "p. ex. 'Connaître tous les aspects pertinents de la 5G pour les décisions politiques', 'Naviguer dans la nouvelle réglementation de l'UE', 'Prendre des décisions éclairées'",
        "audience": "À qui la carte est-elle destinée ?",
        "audienceQ": "À qui la carte est-elle destinée ?"
      },
      "validation": {
        "topic": "Sujet :",
        "topicVal": "La numérisation dans le secteur agricole",
        "purpose": "Objectif :",
        "purposeVal": "Communication & orientation",
        "start": "Situation de départ :",
        "startVal": "Contenu existant à présenter visuellement",
        "goal": "Objectif de communication :",
        "goalVal": "Une vue d'ensemble de tous les aspects pertinents pour mieux décider"
      },
      "phase2": {
        "cat": {
          "a": "Fondamentaux",
          "b": "Application",
          "c": "Cadre"
        },
        "intro": "Passons aux domaines principaux. Comment veux-tu définir les domaines principaux ?",
        "introQ": "Comment veux-tu définir les domaines principaux ?",
        "method": {
          "self": "Je nomme les domaines moi-même",
          "suggest": "Propose-moi des suggestions que je peux ajuster",
          "fromDoc": "Crée les domaines à partir de mon document"
        },
        "outro": "Parfait – les domaines principaux sont maintenant visibles sous forme de points sur le canevas. (Fin simulée du flux de démonstration.)"
      }
    },
    "steps": {
      "2_3": {
        "prompt": "Je te propose quelques domaines principaux à partir de ton sujet."
      },
      "2_3_confirm": {
        "prompt": "Garde, renomme ou supprime des domaines – puis continue."
      },
      "2_1_manual": {
        "prompt": "Nomme tes domaines principaux toi-même – tape un nom et envoie-le. Appuie sur « J'ai terminé » quand tu as fini."
      },
      "2_1_material": {
        "prompt": "Partage un document ou un lien, et je te proposerai les domaines principaux à partir de là. Joins ce que tu as, puis appuie sur « Continuer »."
      },
      "2_5": {
        "prompt": "Voici tes domaines principaux. Est-ce correct ?",
        "value": "Définis sur le canevas"
      },
      "3_1": {
        "prompt": "Quel type de structure convient à ton sujet ?"
      },
      "3_1_order": {
        "prompt": "Tes domaines s'enchaîneront en séquence à mesure qu'on les ajoute."
      },
      "3_1_help": {
        "prompt": "La carte mentale rayonne du centre ; le processus est une séquence ; la carte de contexte montre les liens transversaux ; les îlots sont des blocs indépendants. Lequel convient le mieux ?"
      },
      "3_2": {
        "prompt": "On construit ta carte avec cette structure. Prêt à ajouter tes domaines principaux ?"
      },
      "4_0": {
        "prompt": "Quel domaine veux-tu développer en premier ?",
        "promptNext": "Quel domaine ensuite ? Choisis-en un, ou termine avec « J'ai terminé »."
      },
      "4_1": {
        "prompt": "Comment veux-tu développer les sous-points de {category} ?"
      },
      "4_1_manual": {
        "prompt": "Nomme les sous-points de {category} toi-même – tape un nom et envoie-le. Appuie sur « J'ai terminé » quand tu as fini."
      },
      "4_1_material": {
        "prompt": "Partage un document ou un lien, et je te proposerai des sous-points à partir de là. Joins ce que tu as, puis appuie sur « Continuer »."
      },
      "4_2b": {
        "prompt": "Je te propose quelques sous-points pour {category}."
      },
      "4_2b_confirm": {
        "prompt": "Garde, renomme ou supprime des sous-points – puis continue."
      },
      "4_8": {
        "prompt": "Voici ta structure complète sur le canevas. Ça fonctionne ?",
        "value": "Construit sur le canevas"
      },
      "5_1": {
        "prompt": "Combien de couches ta carte doit-elle avoir ?"
      },
      "5_1_accept": {
        "prompt": "Je vais mettre en place un nombre de couches adapté à ta structure."
      },
      "5_1_override": {
        "prompt": "Combien de couches veux-tu ? Entre un nombre."
      },
      "5_3": {
        "prompt": "J'attribue tes points aux couches …"
      },
      "5_4": {
        "prompt": "Ta structure en couches est prête. Est-ce correct ?",
        "value": "Défini sur le canevas"
      },
      "1_0": {
        "prompt": "Ta carte contient déjà du contenu. Veux-tu que je l'analyse et propose les fondations, ou préfères-tu répondre toi-même aux questions ?"
      },
      "1_1": {
        "prompt": "Commençons par le cœur de ta carte.",
        "emphasis": "Quel sujet ta KontextMap doit-elle couvrir ?"
      },
      "1_2": {
        "prompt": "Dans quel domaine ta carte sera-t-elle utilisée ?"
      },
      "1_2_other": {
        "prompt": "Quel est ton objectif ?"
      },
      "1_2_detail": {
        "prompt": "Tu as choisi « {purpose} ». Peux-tu décrire un peu plus précisément ce que tu veux accomplir avec ?"
      },
      "1_3": {
        "prompt": "Quelle est ta situation de départ ?"
      },
      "1_3_other": {
        "prompt": "Décris brièvement ta situation de départ."
      },
      "1_4": {
        "prompt": "Que doivent comprendre ou savoir faire les utilisateurs après la carte ?",
        "examples": "p. ex. 'Connaître tous les aspects de la 5G pour les décisions politiques', 'Naviguer la nouvelle réglementation européenne', 'Prendre des décisions éclairées'"
      },
      "1_5": {
        "prompt": "À qui s'adresse la carte ?"
      },
      "1_6": {
        "prompt": "Je vérifie rapidement la portée de ton sujet …"
      },
      "1_7": {
        "prompt": "Voici le résumé de ta base. Est-ce correct ?"
      },
      "2_1": {
        "prompt": "Définissons maintenant tes domaines principaux. Comment veux-tu procéder ?"
      },
      "6_0": {
        "prompt": "Place au design et au contenu. Par quoi veux-tu commencer ?"
      },
      "6_0_help": {
        "prompt": "Je recommande le design d'abord, puis le contenu – tu verras le rendu en écrivant. On fait la navigation tout à la fin."
      },
      "6A": {
        "prompt": "L'assistance au design arrive bientôt – je marque l'étape design comme prête pour l'instant."
      },
      "6B": {
        "prompt": "Connecte maintenant ta propre IA dans le Map Builder pour rédiger le contenu de chaque point – je fournis tout le contexte (sujet, public, objectif, structure, mémoire de carte). Je marque le contenu comme prêt."
      },
      "6C": {
        "prompt": "Le design et le contenu sont en place. Prêt à finaliser la navigation ?",
        "value": "Marqué comme prêt"
      },
      "7_1": {
        "prompt": "Configurons la navigation. Comment structurer les points d'entrée ?"
      },
      "7_1_stub": {
        "prompt": "Les points de navigation automatiques arrivent bientôt – pour l'instant tu peux les ajouter toi-même dans le Map Builder."
      },
      "7_5": {
        "prompt": "Ta navigation est prête. Est-ce correct ?",
        "value": "Défini sur la couche 1"
      },
      "4_4_offer": {
        "prompt": "Veux-tu encore quelques idées pour {category} ?"
      },
      "4_4": {
        "prompt": "Quelques sous-points supplémentaires pour {category} :"
      },
      "4_4_confirm": {
        "prompt": "Garde ce qui convient – puis continue."
      },
      "4_5": {
        "prompt": "Lesquels de ces points de {category} doivent rester un nœud à part sur la carte ?"
      },
      "4_5_confirm": {
        "prompt": "Revu – continue."
      },
      "4_5_done": {
        "prompt": "« {category} » est terminé."
      },
      "resume": {
        "prompt": "Veux-tu continuer là où tu t'es arrêté, ou aller à une phase précise ?"
      },
      "resume_jump": {
        "prompt": "À quelle phase veux-tu aller ?"
      },
      "4_3": {
        "prompt": "Certains points pourraient avoir d'autres aspects. Approfondir maintenant ou continuer ?"
      },
      "4_3_pick": {
        "prompt": "Quel point de {category} veux-tu enrichir de sous-aspects ?"
      },
      "4_3_suggest": {
        "prompt": "Voici quelques sous-aspects pour {point}."
      },
      "4_3_confirm": {
        "prompt": "Garde ce qui convient – puis continue."
      },
      "4_7": {
        "prompt": "Je te propose des connexions transversales entre des points liés qui ne le sont pas encore."
      },
      "4_7_confirm": {
        "prompt": "Garde les connexions qui conviennent – puis continue."
      },
      "refine_offer": {
        "prompt": "Veux-tu d'abord préciser l'une de tes réponses précédentes ? Cela m'aide à te donner de meilleurs retours et suggestions."
      },
      "refine_form": {
        "prompt": "Voici tes réponses – modifie-les si besoin, puis revérifie ou continue."
      },
      "completed": {
        "prompt": "Ta carte est terminée. Veux-tu revoir une phase, changer la structure ou fermer ?"
      },
      "completed_jump": {
        "prompt": "Quelle phase veux-tu revoir ?"
      },
      "completed_change_structure": {
        "prompt": "Vers quelle structure dois-je basculer ? Tes domaines et tes points restent — seule leur disposition change."
      },
      "7_1_nav": {
        "prompt": "J'ajoute un point de navigation pour chaque domaine, pour que tes lecteurs puissent zoomer directement dessus."
      },
      "sensemaking_review": {
        "analyzing": "Je regarde ta carte et je rassemble les bases …"
      }
    },
    "fields": {
      "categories": "Domaines principaux",
      "structure_type": "Type de structure",
      "structure": "Structure",
      "layers": "Couches",
      "topic": "Sujet",
      "purpose": "Objectif",
      "purpose_detail": "Détails de l'objectif",
      "starting_situation": "Situation de départ",
      "communication_goal": "Objectif de communication",
      "audience": "Public cible",
      "prior_knowledge": "Connaissances préalables",
      "design_content": "Design & contenu",
      "navigation": "Navigation",
      "anchor": "Point d'ancrage"
    },
    "options": {
      "flow": {
        "continue": "Continuer",
        "done": "J'ai terminé",
        "add_own": "J'ajoute les miens"
      },
      "supplements": {
        "more": "Oui, encore quelques idées",
        "skip": "Non, continuer"
      },
      "onboarding": {
        "help": "Je veux ton aide",
        "own": "Je veux travailler seul"
      },
      "sensemaking": {
        "purpose": {
          "knowledge_management": "Gestion des connaissances & documentation",
          "science_research": "Science & recherche",
          "communication_orientation": "Communication & orientation",
          "strategy_change": "Stratégie & changement",
          "education_training": "Éducation & formation",
          "public_sector": "Secteur public & smart governance",
          "compliance_law": "Conformité & droit",
          "other": "J'ai un autre objectif"
        },
        "starting_situation": {
          "have_expertise": "Nous avons l'expertise et voulons la structurer",
          "have_content": "Nous avons du contenu à présenter visuellement",
          "explain_regulations": "Nous devons expliquer une réglementation à notre public",
          "needs_research": "Le sujet doit d'abord être recherché",
          "other": "J'ai une autre situation de départ"
        }
      },
      "category_formation": {
        "manual": "Je les nomme moi-même",
        "suggestions": "Fais-moi des suggestions",
        "material": "À partir de mon document"
      },
      "structure_choice": {
        "mindmap": "Carte mentale",
        "process": "Processus",
        "network": "Carte de contexte",
        "islands": "Îlots",
        "help": "Aide-moi à choisir"
      },
      "relevance_construction": {
        "choose_category": "Choisir une catégorie"
      },
      "layering": {
        "accept_recommendation": "Suivre la recommandation",
        "override": "Définir moi-même"
      },
      "design_and_content": {
        "design_first": "Design d'abord",
        "content_first": "Contenu d'abord",
        "help": "Aide-moi à choisir"
      },
      "wayfinding": {
        "category_links": "Liens vers les catégories",
        "guiding_question_links": "Questions guides",
        "user_defined_links": "Je les définis"
      },
      "resume": {
        "continue": "Continuer où j'en étais",
        "jump": "Aller à une phase"
      },
      "deepen": {
        "deepen": "Approfondir",
        "skip": "Continuer"
      },
      "refine": {
        "adjust": "Améliorer mes réponses",
        "continue": "Continuer",
        "recheck": "Vérifier à nouveau",
        "done": "Terminé – continuer",
        "topic": "Sujet",
        "purpose": "Objectif",
        "starting_situation": "Situation de départ",
        "communication_goal": "Objectif de communication",
        "audience": "Public cible"
      },
      "completed": {
        "revisit": "Revoir une phase",
        "change_structure": "Changer la structure",
        "close": "Fermer KAIA"
      },
      "removeCategory": "Supprimer cette catégorie et tout ce qu'elle contient",
      "removeCategoryConfirm": "Supprimer « {name} » ainsi que toutes ses sous-catégories et points ? Cette action est irréversible.",
      "recalcLayout": "Recalculer la disposition",
      "recalcLayoutTitle": "Réappliquer cette disposition — réorganise les points sans rien changer d'autre",
      "anchor": {
        "use_selected": "Utiliser le point sélectionné",
        "cancel": "Annuler"
      },
      "sensemaking_entry": {
        "answer": "Je réponds aux questions",
        "analyse": "Analyser ma carte"
      }
    },
    "prose": {
      "suggestionsUnavailable": "Je n'ai pas pu obtenir de suggestions cette fois.",
      "suggestionsKeepFailing": "Les suggestions échouent à répétition en ce moment – continuons et essayons autrement.",
      "aiTimeout": "Le service d'IA a mis trop de temps à répondre – réessaie dans un instant.",
      "reviewUnavailable": "Je n'ai pas pu faire la vérification pour le moment – continuons.",
      "fallbackArea": "ce domaine",
      "fallbackPoint": "ce point",
      "fallbackPurpose": "ton objectif",
      "affectedPhases": "À noter — cette modification peut affecter : {phases}. Rien n'est réinitialisé ; tu peux l'ajuster ici.",
      "manualAdded": "« {name} » ajouté. Ajoutes-en un autre, ou appuie sur « J'ai terminé ».",
      "manualAddFailed": "Je n'ai pas pu créer ce point. Réessaie, ou appuie sur « J'ai terminé ».",
      "greeting": {
        "blank": "Salut ! Je suis KAIA, ton assistante IA pour ta KontextMap. Je te guide étape par étape – on la construit directement dans le Map Builder. Tu veux mon aide ou préfères-tu travailler seul ?",
        "template": "Salut ! Je suis KAIA. Tu pars d'un modèle – je peux t'aider à l'adapter. Tu veux mon aide ou préfères-tu travailler seul ?",
        "welcomeBack": "Bon retour ! Ta carte est déjà en cours."
      },
      "cannotAnswerYet": "Je ne peux pas encore répondre aux questions libres – utilise les options ci-dessus, ou continue seul.",
      "steppedBack": "D'accord, je me retire. Tu peux me rappeler à tout moment.",
      "intro": "Salut ! Je suis KAIA, ton assistante pour créer ta KontextMap. On avance étape par étape, directement dans le Map Builder.",
      "completed": "Ta KontextMap est terminée – toutes les phases sont faites. Tu peux la publier.",
      "materialAdded": "« {name} » ajouté. Je le lis maintenant et je m’en servirai dès que j’aurai fini.",
      "materialAddFailed": "Je n’ai pas pu joindre ça. Essaie un PDF, Word, PowerPoint ou une image — ou un lien.",
      "sensemakingUnavailable": "Je n'ai pas pu analyser ta carte automatiquement — mettons les bases en place ensemble.",
      "pickAnchor": "Sélectionne un point sur la carte, puis choisis « Utiliser le point sélectionné ».",
      "anchorSet": "Point d'ancrage défini sur « {name} ».",
      "noNodeSelected": "Aucun point sélectionné pour l'instant — clique d'abord sur un point de la carte."
    },
    "canvas": {
      "updated": "Le canevas a été mis à jour."
    },
    "thinking": {
      "default": "Laisse-moi réfléchir …",
      "categories": "Je cherche des catégories …",
      "subpoints": "Je cherche des sous-points …",
      "structure": "Je réfléchis à la structure …",
      "connections": "Je cherche des connexions …",
      "layer_count": "Je prépare les couches …",
      "topic_scope": "Je vérifie le périmètre du sujet …",
      "category_quality": "Je vérifie les catégories …",
      "balance": "Je vérifie l'équilibre …",
      "reachability": "Je vérifie la navigation …",
      "sensemaking": "J'analyse ta carte …"
    },
    "openQuestion": {
      "submit": "Envoyer"
    },
    "suggestion": {
      "keep": "Garder",
      "remove": "Supprimer",
      "rename": "Renommer",
      "keepAll": "Tout garder",
      "removeAll": "Tout supprimer"
    },
    "relevance": {
      "keep": "Garder",
      "memory": "Vers la mémoire",
      "unsure": "Incertain",
      "remove": "Supprimer",
      "keepAll": "Tout garder",
      "memoryAll": "Tout vers la mémoire",
      "unsureAll": "Tout incertain"
    },
    "materials": {
      "title": "Documents de cette carte",
      "hint": "Mes suggestions et le texte généré pour chaque point s’appuient sur ces documents. Les lecteurs ne les voient jamais et ils ne sont jamais cités.",
      "none": "Aucun document n’est encore joint à cette carte.",
      "untitled": "Document joint",
      "reading": "Lecture du document…",
      "failed": "Ce document n’a pas pu être lu.",
      "fromDeletedPoint": "D’un point supprimé"
    }
  },
  "features": {
    "headline": {
      "client": "Client {name}",
      "package": "Forfait {name}"
    },
    "section": {
      "quotas": "Quotas",
      "roleQuotas": "Quotas d’utilisateurs par rôle",
      "permissions": "Autorisations",
      "features": "Fonctionnalités",
      "externalContent": "Sources de contenu externes",
      "payment": "Paramètres de paiement",
      "validity": "Validité",
      "content": "Contenus"
    },
    "quota": {
      "layer": "Quota de calques",
      "map": "Quota de cartes",
      "storage": "Quota de stockage",
      "liveMap": "Quota de cartes en direct",
      "template": "Quota de modèles",
      "traffic": "Quota de trafic",
      "user": "Quota d’utilisateurs",
      "admin": "Quota d’utilisateurs administrateurs",
      "editor": "Quota d’utilisateurs éditeurs",
      "guest": "Quota d’utilisateurs invités",
      "student": "Quota d’utilisateurs élèves",
      "activeReaders": "Quota de lecteurs actifs",
      "editingUser": "Quota d’utilisateurs éditant les cartes"
    },
    "quotaHint": {
      "layer": "Nombre maximal de calques par carte",
      "map": "Nombre maximal de cartes",
      "storage": "Limite des médias stockés en Mio",
      "liveMap": "Nombre maximal de cartes pouvant être publiées",
      "template": "Nombre maximal de modèles d’objets personnalisés",
      "traffic": "Limite mensuelle de données transférées en Mio",
      "user": "Nombre maximal d’utilisateurs",
      "admin": "Nombre maximal d’utilisateurs ayant le rôle administrateur",
      "editor": "Nombre maximal d’utilisateurs ayant le rôle éditeur",
      "guest": "Nombre maximal d’utilisateurs ayant le rôle invité",
      "student": "Nombre maximal d’utilisateurs ayant le rôle élève",
      "activeReaders": "Limite mensuelle de visiteurs",
      "editingUser": "Nombre maximal d’utilisateurs pouvant modifier les cartes"
    },
    "can": {
      "editMap": "Modifier les cartes",
      "editPopups": "Modifier le contenu des popups",
      "embedMap": "Intégrer les cartes sur d’autres sites",
      "publicMaps": "Publier les cartes",
      "privateMaps": "Conserver des cartes en brouillon",
      "selectDesignTemplates": "Utiliser des modèles d’objets",
      "saveMapState": "Enregistrer l’état de la carte du lecteur"
    },
    "has": {
      "analytics": "Analytique dans les cartes",
      "articles": "Articles longs",
      "assistant": "Assistant de création KAIA",
      "contentLlm": "Génération de contenu par IA",
      "assetManagement": "Gestion des médias",
      "cname": "Domaine personnalisé (CNAME)",
      "cookieConsent": "Boîte de dialogue de consentement aux cookies",
      "customDesign": "Paramètres de design sur les points et les connexions",
      "customLoginPage": "Page de connexion personnalisée",
      "designTemplates": "Créer des modèles d’objets",
      "editorial": "Note de la rédaction",
      "globalDesign": "Règles de design globales",
      "glossary": "Glossaire",
      "i18n": "Plusieurs langues",
      "mapHeader": "En-tête de carte",
      "mcpServer": "Serveur MCP",
      "mediaTemplates": "Modèles de médias",
      "meteredMaps": "Cartes avec comptage d’accès",
      "mfa": "Authentification à deux facteurs",
      "premiumTemplates": "Modèles premium",
      "quizzes": "Quiz",
      "references": "Références et bibliographie",
      "search": "Recherche en texte intégral",
      "seo": "Options SEO supplémentaires",
      "socialNetworkSharing": "Boutons de partage dans les popups",
      "studentRole": "Rôle élève",
      "subdomain": "Sous-domaine",
      "templates": "Modèles de cartes",
      "toc": "Table des matières",
      "translationService": "Service de traduction",
      "userAccessControl": "Contrôle d’accès par carte"
    },
    "field": {
      "clientName": "Nom du client",
      "packageName": "Nom du forfait",
      "paymentProvider": "Prestataire de paiement",
      "customerId": "Identifiant client",
      "activeSince": "Actif depuis",
      "activeUntil": "Actif jusqu’au",
      "testingPeriodUntil": "Période d’essai jusqu’au",
      "testingPeriodDays": "Période d’essai en jours",
      "dateHint": "AAAA-MM-JJ hh:mm:ss",
      "fonts": "Polices",
      "mediaCategories": "Catégories de médias",
      "templateThemes": "Thèmes de modèles",
      "traffic": "Trafic inclus en Mio",
      "slug": "Slug",
      "slugHint": "Identifiant dérivé du nom. Le prestataire de paiement y associe ses produits."
    },
    "save": "Enregistrer",
    "savedMessage": "Paramètres modifiés avec succès !",
    "loadError": "Une erreur est survenue lors du chargement des paramètres !",
    "saveError": "Une erreur est survenue lors de l’enregistrement des paramètres !",
    "categoriesError": "Une erreur est survenue lors du chargement des catégories de médias",
    "payment": {
      "noProvider": "Aucun",
      "notLinked": "Ce forfait n'est encore relié à aucun produit, ses liens de paiement ne fonctionnent donc pas.",
      "chooseProduct": "Produit existant",
      "chooseOtherProduct": "Passer à un autre produit",
      "newProduct": "Ou créer un nouveau produit",
      "link": "Relier",
      "move": "Changer",
      "create": "Créer et relier",
      "unlink": "Dissocier",
      "working": "Communication avec le prestataire de paiement…",
      "openAtProvider": "Modifier chez {provider}",
      "productTaken": "{name} (appartient à {slug})",
      "extensions": "Options vendues avec ce forfait. Gérées chez le prestataire de paiement.",
      "missingPrices": "Aucun tarif pour : {intervals}. Cette périodicité ne peut pas être achetée tant qu'aucun tarif n'est défini chez le prestataire de paiement.",
      "stateMissing": "Le produit relié n'existe plus chez le prestataire de paiement. Reliez-en un autre.",
      "stateMismatched": "Ce produit appartient à un autre forfait, ou a été relié à la main chez le prestataire de paiement. Reliez-le ici pour le reprendre.",
      "loadError": "Le prestataire de paiement est injoignable.",
      "linkError": "Le produit n'a pas pu être relié.",
      "createError": "Le produit n'a pas pu être créé.",
      "unlinkError": "La liaison n'a pas pu être supprimée.",
      "detected": "{provider} vend déjà ce forfait sous le nom « {name} ». Enregistrez-le ici pour pouvoir renommer le forfait, le relier à un autre produit ou le dissocier depuis le tableau de bord.",
      "adopt": "Utiliser ce produit",
      "adoptHint": "Rien ne change chez le prestataire de paiement et le paiement continue de fonctionner à l'identique."
    }
  },
  "packages": {
    "headerTitle": "Forfaits",
    "addPackage": "Ajouter un nouveau forfait",
    "createPackage": "Créer un forfait",
    "cancel": "Annuler",
    "packageName": "Quel est le nom du forfait ?",
    "cloneName": "Nom de la copie",
    "inactive": "Inactif",
    "edit": "Modifier le forfait",
    "clone": "Cloner le forfait",
    "deletePackage": "Supprimer définitivement",
    "copyLinkYear": "Copier le lien d’achat annuel",
    "copyLinkMonth": "Copier le lien d’achat mensuel",
    "linkCopied": "Lien d’achat copié dans le presse-papiers",
    "linkCopyFailed": "Le lien d’achat n’a pas pu être copié",
    "maps": "Nombre de cartes :",
    "users": "Nombre d’utilisateurs :",
    "trial": "Période d’essai :",
    "trialDays": "{count} jours",
    "noTrial": "Aucune",
    "unlimited": "Illimité",
    "createError": "Le forfait n’a pas pu être créé",
    "cloneError": "Le forfait n’a pas pu être cloné",
    "deleteError": "Le forfait n’a pas pu être supprimé",
    "searchPlaceholder": "Rechercher des forfaits...",
    "copySuffix": "{name} (copie)",
    "cloneTitle": "Cloner le forfait",
    "cloneConfirm": "Cloner",
    "payment": {
      "linked": "Mis en vente",
      "linkedHint": "Ce forfait est relié à un produit chez son prestataire de paiement et peut être acheté.",
      "missingPrices": "Tarif manquant",
      "detected": "Liaison non enregistrée",
      "detectedHint": "Le prestataire de paiement vend déjà ce forfait, mais la liaison n’est pas encore enregistrée ici. Ouvrez le forfait pour l’enregistrer.",
      "missing": "Produit disparu",
      "mismatched": "Mauvais produit",
      "unlinked": "Non relié"
    }
  },
  "fonts": {
    "headerTitle": "Polices",
    "searchPlaceholder": "Rechercher des polices ...",
    "loadError": "Les polices n'ont pas pu être chargées",
    "empty": "Aucune police pour le moment",
    "emptySearch": "Aucune police ne correspond à cette recherche",
    "table": {
      "id": "ID",
      "family": "Famille",
      "from": "Source",
      "created": "Ajoutée",
      "actions": "Actions",
      "updated": "Modifiée"
    },
    "from": {
      "google": "Google Fonts",
      "library": "Bibliothèque de polices",
      "external": "Externe",
      "unknown": "Inconnue"
    },
    "fromDerived": "Non enregistrée ; déduite de l'adresse de la feuille de style",
    "servedFrom": "Servie par {host}",
    "editFont": "Modifier la police",
    "removeFont": "Supprimer la police",
    "import": {
      "open": "Importer une police",
      "title": "Importer une police",
      "description": "Choisissez d’où vient la police. Voici ce que font les options :",
      "sourceLabel": "Importer depuis",
      "sourceHints": {
        "google": "Télécharge la famille depuis Google Fonts et la stocke ici. Les cartes servent ensuite la police elles-mêmes, si bien qu’aucun navigateur de visiteur ne la demande à Google.",
        "library": "Enregistre une famille déjà présente ici. Rien n’est téléchargé ; la police devient simplement sélectionnable dans le Map Builder.",
        "external": "Relie une feuille de style à l’adresse que vous saisissez. Les fichiers de police restent sur cet hôte et sont chargés depuis celui-ci."
      },
      "external": "Feuille de style externe",
      "externalDescription": "À n’utiliser que pour un hôte qui vous appartient : les visiteurs y chargent la police directement.",
      "url": "Adresse de la feuille de style",
      "searchPlaceholder": "Trouver une famille ...",
      "variants": "{count} graisses",
      "noVariants": "Aucune graisse",
      "alreadyImported": "Déjà importée",
      "empty": "Aucune famille trouvée",
      "familiesError": "Les familles n'ont pas pu être chargées",
      "chosenFamily": "Famille",
      "displayName": "Nom affiché",
      "displayNameHint": "Par défaut, le nom de la famille",
      "fallback": "Police de repli",
      "fallbackHint": "Ce que le navigateur affiche pendant le chargement",
      "submit": "Importer",
      "cancel": "Annuler",
      "error": "La police n'a pas pu être importée",
      "conflict": "Une police existe déjà pour cette famille",
      "success": "{name} a été importée"
    },
    "edit": {
      "title": "Modifier la police",
      "name": "Nom affiché",
      "family": "Pile de polices",
      "familyHint": "Telle qu'utilisée en CSS, se terminant par une famille générique",
      "source": "Feuille de style",
      "refresh": "Mettre à jour depuis la source",
      "refreshHint": "Relit la feuille de style et remplace les graisses de la police",
      "refreshUnavailable": "L'origine de cette police n'a jamais été enregistrée ; elle ne peut donc pas être relue automatiquement",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "error": "La police n'a pas pu être enregistrée",
      "refreshError": "La police n'a pas pu être mise à jour depuis sa source",
      "refreshed": "{name} a été mise à jour depuis sa source"
    },
    "remove": {
      "title": "Supprimer la police",
      "question": "Voulez-vous vraiment supprimer la police « {name} » ?",
      "clients": "Elle est disponible pour {count} client(s) : {clients}",
      "noClients": "Aucun client n'utilise cette police.",
      "warning": "Elle sera retirée à ces clients, et chaque composant de carte qui l'utilise reviendra à la valeur par défaut du design.",
      "confirm": "Supprimer définitivement",
      "cancel": "Annuler",
      "error": "La police n'a pas pu être supprimée",
      "success": "{name} a été supprimée"
    }
  }
}
